export const DEFAULT_ISO_CODE = 'NZ';
export const STANDARD_GRID = `grid lg:grid-cols-3 gap-x-10 gap-space-s`;

export const BINDING_FILTERS = [
  'meta.bookinfo_thorpe.onix_binding:Hardback',
  'meta.bookinfo_thorpe.onix_binding:Paperback',
  'meta.bookinfo_ebility.binding:HB',
  'meta.bookinfo_ebility.binding:PB',
  'meta.bookinfo_ebility.binding:TP',
  'meta.bookinfo_ebility.binding:BO',
  'meta.bookinfo_ebility.binding:CL',
].join(' OR ');

export const GIFTCARD_HANDLES = [
  'e-voucher-online-only',
  'booksellers-token',
  'unity-voucher-physical',
];

export type StatusCode =
  | 'NYP'
  | 'JAN'
  | 'FEB'
  | 'MAR'
  | 'APR'
  | 'MAY'
  | 'JUN'
  | 'JUL'
  | 'AUG'
  | 'SEP'
  | 'OCT'
  | 'NOV'
  | 'DEC'
  | 'RP'
  | 'ACT'
  | 'POD';

const PRE_ORDER_STATUS_CODES: StatusCode[] = [
  'NYP',
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
];
export const ON_ITS_WAY_STATUS_CODES: StatusCode[] = ['ACT', 'POD', 'RP'];

export const ACTIVE_STATUS_CODES: StatusCode[] = [
  ...PRE_ORDER_STATUS_CODES,
  ...ON_ITS_WAY_STATUS_CODES,
];

export type Category = {
  webDepartment: {
    name:
      | 'AOTEAROA NZ'
      | 'FICTION & POETRY'
      | 'CHILDREN & YOUNG ADULT'
      | 'NON FICTION';
    mainCategories: {
      name:
        | 'AOTEAROA NZ'
        | 'FICTION & POETRY'
        | 'CHILDREN & YOUNG ADULT'
        | 'BIOGRAPHY & MEMOIR'
        | 'TRAVEL'
        | 'THE ARTS'
        | 'HISTORY'
        | 'POLITICS'
        | 'PHILOSOPHY'
        | 'GARDENING'
        | 'FEMINISM'
        | 'SPORT'
        | 'TRANSPORT'
        | 'LGBTQIA+'
        | 'FOOD & DRINK'
        | 'ESSAYS & REFERENCE'
        | 'REFERENCE'
        | 'SPIRITUALITY & RELIGION'
        | 'HEALTH & WELLBEING'
        | 'SOCIETY, CULTURE & TECHNOLOGY'
        | 'SCIENCE & NATURE'
        | 'BUSINESS & ECONOMICS'
        | 'NON FICTION';
      subCategories: {
        name:
          | 'NON FICTION'
          | 'THE ARTS'
          | 'REFERENCE'
          | 'FICTION & POETRY'
          | 'EUROPEAN FICTION'
          | 'HEALTH & WELLBEING'
          | 'AOTEAROA NZ ART'
          | 'AOTEAROA NZ BIOGRAPHY'
          | 'AOTEAROA NZ BUSINESS'
          | 'AOTEAROA NZ CHILDRENS & YOUNG ADULT'
          | 'AOTEAROA NZ FICTION'
          | 'AOTEAROA NZ FOOD & DRINK'
          | 'AOTEAROA NZ NON FICTION'
          | 'AOTEAROA NZ PLANTS & ANIMALS'
          | 'AOTEAROA NZ POETRY'
          | 'AOTEAROA NZ POLITICS'
          | 'AOTEAROA NZ TRAVEL'
          | 'AOTEAROA NZ NONFICTION'
          | 'AOTEAROA NZ PICTURE BOOKS'
          | 'AOTEAROA NZ JUNIOR FICTION'
          | 'AOTEAROA NZ MIDDLE FICTION'
          | 'AOTEAROA NZ YOUNG ADULT FICTION'
          | 'AOTEAROA NZ CHILDRENS NONFICTION'
          | 'AOTEAROA NZ BIOGRAPHY'
          | 'AOTEAROA NZ TRAVEL'
          | 'AOTEAROA NZ HISTORY'
          | 'AOTEAROA NZ GARDENING'
          | 'AOTEAROA NZ BUSINESS'
          | 'FOOD & DRINK'
          | 'POLITICS'
          | 'BIOGRAPHY & MEMOIR'
          | 'TE AO MAORI'
          | 'TE REO MAORI'
          | 'TRAVEL'
          | 'FICTION'
          | 'POETRY'
          | 'CRIME FICTION'
          | 'SCIENCE FICTION & FANTASY'
          | 'CLASSICS'
          | 'CLASSIC FICTION'
          | 'GRAPHIC NOVELS'
          | 'CHILDREN & YOUNG ADULT BOOKS IN TE REO MAORI'
          | 'CHILDREN & YOUNG ADULT'
          | 'GRAPHIC NOVELS FOR CHILDREN & YOUNG ADULT'
          | 'BOARD BOOKS'
          | 'PICTURE BOOKS'
          | 'GRAPHIC NOVELS FOR CHILDREN & YOUNG ADULTS'
          | 'JUNIOR FICTION'
          | 'MIDDLE FICTION'
          | 'YOUNG ADULT FICTION'
          | 'CHILDRENS NONFICTION'
          | 'CHILDRENS CLASSICS'
          | 'LGBTQ+'
          | 'LGBTQIA+'
          | 'LGBTQIA+ CHILDREN & YOUNG ADULT'
          | 'HISTORICAL BIOGRAPHY'
          | 'LITERARY BIOGRAPHY'
          | 'POLITICAL BIOGRAPHY'
          | 'TRAVEL GUIDES'
          | 'TRAVEL WRITING'
          | 'ARCHITECTURE'
          | 'ART'
          | 'DESIGN & CRAFT'
          | 'FASHION'
          | 'FILM & TELEVISION'
          | 'MUSIC'
          | 'PHOTOGRAPHY'
          | 'THEATRE'
          | 'HISTORY'
          | 'ESSAYS & REFERENCE'
          | 'AFRICAN HISTORY'
          | 'ANCIENT & CLASSICAL HISTORY'
          | 'ASIAN HISTORY'
          | 'EUROPEAN HISTORY'
          | 'GLOBAL HISTORY'
          | 'HISTORY OF THE AMERICAS'
          | 'HISTORY OF THE MIDDLE EAST'
          | 'MILITARY HISTORY'
          | 'OCEANIA HISTORY'
          | 'POLITICAL BIOGRAPHY'
          | 'AOTEAROA NZ POLITICS'
          | 'AMERICAN POLITICS'
          | 'EUROPEAN POLITICS'
          | 'ASIAN POLITICS'
          | 'GARDENING'
          | 'LGBTQIA+ FICTION'
          | 'LGBTQIA+ NONFICTION'
          | 'LGBTQIA+ CHILDREN & YOUNG ADULT'
          | 'BAKING & DESSERTS'
          | 'DRINK'
          | 'DRINKS'
          | 'FOOD WRITING'
          | 'VEGETARIAN & VEGAN'
          | 'DICTIONARIES & ATLASES'
          | 'ESSAYS'
          | 'FOREIGN LANGUAGE'
          | 'HUMOUR, PUZZLES & GAMES'
          | 'LANGUAGE & LINGUISTICS'
          | 'MYTHS & LEGENDS'
          | 'TE REO MAORI'
          | 'LITERARY CRITICISM, BOOKS & WRITING GUIDES'
          | 'SPIRITUALITY & RELIGION'
          | 'TAROT & ASTROLOGY'
          | 'YOGA & MEDITATION'
          | 'DIET & NUTRITION'
          | 'MENTAL HEALTH'
          | 'MORTALITY & GRIEF'
          | 'PREGNANCY & PARENTING'
          | 'SELF HELP'
          | 'SEX & RELATIONSHIPS'
          | 'SOCIETY & CULTURE'
          | 'TECHNOLOGY'
          | 'TRUE CRIME'
          | 'ANIMALS'
          | 'BIOLOGY & EVOLUTION'
          | 'CLIMATE CHANGE'
          | 'GENERAL SCIENCE'
          | 'MATHEMATICS'
          | 'MEDICINE'
          | 'PHYSICS & CHEMISTRY'
          | 'PSYCHOLOGY & THE BRAIN'
          | 'SPACE & ASTRONOMY'
          | 'THE NATURAL WORLD'
          | 'ECONOMICS'
          | 'BUSINESS'
          | 'PHILOSOPHY'
          | 'FEMINISM'
          | 'SPORT'
          | 'TRANSPORT'
          | 'LANGUAGE & LINGUISTICS'
          | 'LANGUAGE & LINGUSTICS'
          | 'SCIENCE & NATURE';
        ebilityCategories: {
          code: string;
          name: string;
        }[];
      }[];
    }[];
  };
};

export const CATEGORIES: Category[] = [
  {
    webDepartment: {
      name: 'AOTEAROA NZ',
      mainCategories: [
        {
          name: 'AOTEAROA NZ',
          subCategories: [
            {
              name: 'AOTEAROA NZ ART',
              ebilityCategories: [
                {
                  code: 'MAOART',
                  name: 'Maori Art',
                },
                {
                  code: 'NZARCH',
                  name: 'NZ Architecture',
                },
                {
                  code: 'NZART',
                  name: 'NZ Art',
                },
                {
                  code: 'NZDESI',
                  name: 'NZ Design',
                },
                {
                  code: 'NZPHOT',
                  name: 'NZ Photography',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ BIOGRAPHY',
              ebilityCategories: [
                {
                  code: 'MAOBIO',
                  name: 'Maori Biography',
                },
                {
                  code: 'NZBIOG',
                  name: 'NZ Biography',
                },
                {
                  code: 'NZMEMO',
                  name: 'NZ Memoir',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ BUSINESS',
              ebilityCategories: [
                {
                  code: 'NZBUSI',
                  name: 'NZ Business',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ CHILDRENS & YOUNG ADULT',
              ebilityCategories: [
                {
                  code: 'NZKIPO',
                  name: 'NZ Kid Poetry',
                },
                {
                  code: 'NZTEEN',
                  name: 'NZ Teen Fiction',
                },
                {
                  code: 'NZYAF',
                  name: 'NZ Teen Fiction',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ FICTION',
              ebilityCategories: [
                {
                  code: 'MAOFIC',
                  name: 'Maori Fiction',
                },
                {
                  code: 'NZANTH',
                  name: 'NZ Anthologies',
                },
                {
                  code: 'NZCRIF',
                  name: 'NZ Crime Fiction',
                },
                {
                  code: 'NZFANT',
                  name: 'NZ Fantasy',
                },
                {
                  code: 'NZFICT',
                  name: 'NZ Fiction',
                },
                {
                  code: 'NZHISF',
                  name: 'NZ Historical Fiction',
                },
                {
                  code: 'NZLITE',
                  name: 'NZ Literature',
                },
                {
                  code: 'NZPLAY',
                  name: 'NZ Plays',
                },
                {
                  code: 'NZSCFI',
                  name: 'NZ Science Fiction',
                },
                {
                  code: 'NZSHOR',
                  name: 'NZ Short Stories',
                },
                {
                  code: 'NZTRAV',
                  name: 'NZ Travel',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ FOOD & DRINK',
              ebilityCategories: [
                {
                  code: 'NZCOOK',
                  name: 'NZ Cooking',
                },
                {
                  code: 'NZWINE',
                  name: 'NZ Wine',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ NON FICTION',
              ebilityCategories: [
                {
                  code: 'BWBTEX',
                  name: 'BWB Text',
                },
                {
                  code: 'NZNON',
                  name: 'NZ Nonfiction',
                },
                {
                  code: 'NZSCIE',
                  name: 'NZ Science',
                },
                {
                  code: 'NZSUST',
                  name: 'NZ Sustainability',
                },
                {
                  code: 'NZREGI',
                  name: 'NZ Regions',
                },
                {
                  code: 'NZREF',
                  name: 'NZ Reference',
                },
                {
                  code: 'NZLAW',
                  name: 'NZ Legal Issues',
                },
                {
                  code: 'NZLANG',
                  name: 'NZ Language',
                },
                {
                  code: 'NZHEAL',
                  name: 'NZ Health',
                },
                {
                  code: 'NZGEOL',
                  name: 'NZ Geology',
                },
                {
                  code: 'NZFEMS',
                  name: 'NZ Feminism',
                },
                {
                  code: 'NZFARM',
                  name: 'NZ Farming',
                },
                {
                  code: 'NZFAMI',
                  name: 'NZ Family',
                },
                {
                  code: 'NZENVI',
                  name: 'NZ Environment',
                },
                {
                  code: 'NZEDUC',
                  name: 'NZ Education',
                },
                {
                  code: 'NZECOL',
                  name: 'NZ Ecology',
                },
                {
                  code: 'NZAGRI',
                  name: 'NZ Agriculture',
                },
                {
                  code: 'MAOCUL',
                  name: 'Maori Culture',
                },
                {
                  code: 'MAOEDU',
                  name: 'Maori Education',
                },
                {
                  code: 'MAOHEA',
                  name: 'Maori Health',
                },
                {
                  code: 'MAOLAW',
                  name: 'Maori Law',
                },
                {
                  code: 'MAOMUS',
                  name: 'Maori Music',
                },
                {
                  code: 'MAONON',
                  name: 'Maori Non Fiction',
                },
                {
                  code: 'MAOREF',
                  name: 'Maori Reference',
                },
                {
                  code: 'MAORIW',
                  name: 'Maori Women',
                },
                {
                  code: 'MAORLI',
                  name: 'Maori Land Issues',
                },
                {
                  code: 'MAOSPO',
                  name: 'Maori Sport',
                },
                {
                  code: 'MAOSPR',
                  name: 'Maori Spirituality',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ PLANTS & ANIMALS',
              ebilityCategories: [
                {
                  code: 'NZNATU',
                  name: 'NZ Natural History',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ POETRY',
              ebilityCategories: [
                {
                  code: 'NZPOET',
                  name: 'NZ Poetry',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ POLITICS',
              ebilityCategories: [
                {
                  code: 'NZPOLI',
                  name: 'NZ Politics',
                },
                {
                  code: 'MAOPOL',
                  name: 'Maori Politics',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ TRAVEL',
              ebilityCategories: [
                {
                  code: 'NZPICT',
                  name: 'NZ Pictorial',
                },
                {
                  code: 'NZTRAV',
                  name: 'NZ Travel',
                },
                {
                  code: 'ROADCO',
                  name: 'NZ Road Code',
                },
                {
                  code: 'KIWIAN',
                  name: 'Kiwiana',
                },
              ],
            },
            {
              name: 'TE AO MAORI',
              ebilityCategories: [
                {
                  code: 'WAITAN',
                  name: 'Waitangi Issues',
                },
                {
                  code: 'MATARI',
                  name: 'Matariki',
                },
                {
                  code: 'MAOART',
                  name: 'Maori Art',
                },
                {
                  code: 'MAOBIO',
                  name: 'Maori Biography',
                },
                {
                  code: 'MAOCUL',
                  name: 'Maori Culture',
                },
                {
                  code: 'MAOEDU',
                  name: 'Maori Education',
                },
                {
                  code: 'MAOFIC',
                  name: 'Maori Fiction',
                },
                {
                  code: 'MAOHEA',
                  name: 'Maori Health',
                },
                {
                  code: 'MAOHIS',
                  name: 'Maori History',
                },
                {
                  code: 'MAOLAW',
                  name: 'Maori Law',
                },
                {
                  code: 'MAOMUS',
                  name: 'Maori Music',
                },
                {
                  code: 'MAOMYT',
                  name: 'Maori Myth&Legends',
                },
                {
                  code: 'MAONON',
                  name: 'Maori Non Fiction',
                },
                {
                  code: 'MAOPOL',
                  name: 'Maori Politics',
                },
                {
                  code: 'MAOPRO',
                  name: 'Maori Proverbs',
                },
                {
                  code: 'MAOREF',
                  name: 'Maori Reference',
                },
                {
                  code: 'MAORI',
                  name: 'Maori',
                },
                {
                  code: 'MAORIW',
                  name: 'Maori Women',
                },
                {
                  code: 'MAORLI',
                  name: 'Maori Land Issues',
                },
                {
                  code: 'MAOSPO',
                  name: 'Maori Sport',
                },
                {
                  code: 'MAOSPR',
                  name: 'Maori Spirituality',
                },
              ],
            },
            {
              name: 'TE REO MAORI',
              ebilityCategories: [
                {
                  code: 'MAOKID',
                  name: 'Maori Kids Books',
                },
                {
                  code: 'TEREO',
                  name: 'Te Reo',
                },
                {
                  code: 'KTEREL',
                  name: 'Kids Te Reo Learning',
                },
                {
                  code: 'KTEREO',
                  name: 'Kids Te Reo Books',
                },
              ],
            },
          ],
        },
      ],
    },
  },
  {
    webDepartment: {
      name: 'FICTION & POETRY',
      mainCategories: [
        {
          name: 'FICTION & POETRY',
          subCategories: [
            {
              name: 'FICTION',
              ebilityCategories: [
                {
                  code: 'TOLKIE',
                  name: 'Tolkien',
                },
                {
                  code: 'MALFIC',
                  name: 'Malaysian Fiction',
                },
                {
                  code: 'KORFIC',
                  name: 'Korean fiction',
                },
                {
                  code: 'JEWFIC',
                  name: 'Jewish Fiction',
                },
                {
                  code: 'JAPFIC',
                  name: 'Japanese Fiction',
                },
                {
                  code: 'ITAFIC',
                  name: 'Italian Fiction',
                },
                {
                  code: 'ISRFIC',
                  name: 'Israeli Fiction',
                },
                {
                  code: 'IRNFIC',
                  name: 'Iranian Fiction',
                },
                {
                  code: 'IRIFIC',
                  name: 'Irish Fiction',
                },
                {
                  code: 'IRAFIC',
                  name: 'Iranian Fiction',
                },
                {
                  code: 'INDFIC',
                  name: 'Indian Fiction',
                },
                {
                  code: 'ICEFIC',
                  name: 'Icelandic Fiction',
                },
                {
                  code: 'HUNFIC',
                  name: 'Hungarian Fiction',
                },
                {
                  code: 'HOBBIT',
                  name: 'Hobbit Books',
                },
                {
                  code: 'HISFIC',
                  name: 'Historical Fiction',
                },
                {
                  code: 'GREFIC',
                  name: 'Greek Fiction',
                },
                {
                  code: 'GHOSTS',
                  name: 'Ghost Stories',
                },
                {
                  code: 'GERFIC',
                  name: 'German Fiction',
                },
                {
                  code: 'FREFIC',
                  name: 'French Fiction',
                },
                {
                  code: 'FINFIC',
                  name: 'Finnish Fiction',
                },
                {
                  code: 'EURFIC',
                  name: 'European Fiction',
                },
                {
                  code: 'EROFIC',
                  name: 'Erotic Fiction',
                },
                {
                  code: 'EGYFIC',
                  name: 'Egyptian Fiction',
                },
                {
                  code: 'DUTFIC',
                  name: 'Dutch Fiction',
                },
                {
                  code: 'CZEFIC',
                  name: 'Czech Fiction',
                },
                {
                  code: 'CUBFIC',
                  name: 'Cuban Fiction',
                },
                {
                  code: 'COMFIC',
                  name: 'Comic Fiction',
                },
                {
                  code: 'COLFIC',
                  name: 'Columbian Fiction',
                },
                {
                  code: 'CHILFI',
                  name: 'Chilean fiction',
                },
                {
                  code: 'CHIFIC',
                  name: 'Chinese fiction',
                },
                {
                  code: 'CARFIC',
                  name: 'Caribbean Fiction',
                },
                {
                  code: 'CANFIC',
                  name: 'Canadian Fiction',
                },
                {
                  code: 'PACFIC',
                  name: 'Pacific Fiction',
                },
                {
                  code: 'AFRFIC',
                  name: 'African Fiction',
                },
                {
                  code: 'BRAFIC',
                  name: 'Brazilian Fiction',
                },
                {
                  code: 'BRIFIC',
                  name: 'British Fiction',
                },
                {
                  code: 'AMEFIC',
                  name: 'American Fiction',
                },
                {
                  code: 'ARAFIC',
                  name: 'Arabic Fiction',
                },
                {
                  code: 'ARGFIC',
                  name: 'Argentinian Fiction',
                },
                {
                  code: 'ASIFIC',
                  name: 'Asian Fiction',
                },
                {
                  code: 'AUSFIC',
                  name: 'Australian Fiction',
                },
                {
                  code: 'MEXFIC',
                  name: 'Mexican Fiction',
                },
                {
                  code: 'MIDFIC',
                  name: 'Middle Eastern Fiction',
                },
                {
                  code: 'MILFIC',
                  name: 'Military Fiction',
                },
                {
                  code: 'MUSFIC',
                  name: 'Music Fiction',
                },
                {
                  code: 'MYTFIC',
                  name: 'Myth/Legend told as',
                },
                {
                  code: 'NAMFIC',
                  name: 'Native American Fict',
                },
                {
                  code: 'NIGFIC',
                  name: 'Nigerian Fiction',
                },
                {
                  code: 'NORFIC',
                  name: 'Norwegian Fiction',
                },
                {
                  code: 'NOVELL',
                  name: 'Novellas',
                },
                {
                  code: 'PAKFIC',
                  name: 'PAKISTAN FICTION',
                },
                {
                  code: 'PERFIC',
                  name: 'Peruvian Fiction',
                },
                {
                  code: 'POLFIC',
                  name: 'Polish Fiction',
                },
                {
                  code: 'PORFIC',
                  name: 'Portuguese Fiction',
                },
                {
                  code: 'QUEERO',
                  name: 'Queer Erotica',
                },
                {
                  code: 'QUEFIC',
                  name: 'Queer Fiction',
                },
                {
                  code: 'ROMFIC',
                  name: 'Romantic Fiction',
                },
                {
                  code: 'RUSFIC',
                  name: 'Russian Fiction',
                },
                {
                  code: 'SAFFIC',
                  name: 'Sth African Fiction',
                },
                {
                  code: 'SAMFIC',
                  name: 'Samoan Fiction',
                },
                {
                  code: 'SCOFIC',
                  name: 'Scottish Fiction',
                },
                {
                  code: 'SHORTS',
                  name: 'Short Stories',
                },
                {
                  code: 'SLOFIC',
                  name: 'Slovenian Fiction',
                },
                {
                  code: 'SOAFIC',
                  name: 'South American Fiction',
                },
                {
                  code: 'SOKFIC',
                  name: 'South Korean Fiction',
                },
                {
                  code: 'SPAFIC',
                  name: 'Spanish Fiction',
                },
                {
                  code: 'SPRFIC',
                  name: 'Spiritual Fiction',
                },
                {
                  code: 'SRIFIC',
                  name: 'Sri Lankan Fiction',
                },
                {
                  code: 'SWEFIC',
                  name: 'Swedish Fiction',
                },
                {
                  code: 'SRIFIC',
                  name: 'Sri Lankan Fiction',
                },
                {
                  code: 'TRAFIC',
                  name: 'Transgender Fiction',
                },
                {
                  code: 'TURFIC',
                  name: 'Turkish Fiction',
                },
                {
                  code: 'VIEFIC',
                  name: 'Vietnamese fiction',
                },
                {
                  code: 'WELFIC',
                  name: 'Welsh Fiction',
                },
                {
                  code: 'WW1FIC',
                  name: 'World War 1 Fiction',
                },
                {
                  code: 'WW2FIC',
                  name: 'World War 2 Fiction',
                },
                {
                  code: 'ZIMFIC',
                  name: 'Zimbabwe Fiction',
                },
                {
                  code: 'FICTIO',
                  name: 'Fiction',
                },
                {
                  code: 'MIDHIS',
                  name: 'Middle East History',
                },
                {
                  code: 'AFGFIC',
                  name: 'Afghanistani Fiction',
                },
                {
                  code: 'BISFIC',
                  name: 'Bisexual Fiction',
                },
              ],
            },
            {
              name: 'FICTION & POETRY',
              ebilityCategories: [
                {
                  code: 'ANTHOL',
                  name: 'Anthologies',
                },
              ],
            },
            {
              name: 'EUROPEAN FICTION',
              ebilityCategories: [
                {
                  code: 'GERHIS',
                  name: 'German History',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ FICTION',
              ebilityCategories: [
                {
                  code: 'NZHISF',
                  name: 'NZ Historical Fiction',
                },
                {
                  code: 'MAOFIC',
                  name: 'Maori Fiction',
                },
                {
                  code: 'NZANTH',
                  name: 'NZ Anthologies',
                },
                {
                  code: 'NZFANT',
                  name: 'NZ Crime Fiction',
                },
                {
                  code: 'NZHISF',
                  name: 'NZ Fantasy',
                },
                {
                  code: 'NZFICT',
                  name: 'NZ Fiction',
                },
                {
                  code: 'NZLITE',
                  name: 'NZ Literature',
                },
                {
                  code: 'NZPLAY',
                  name: 'NZ Plays',
                },
                {
                  code: 'NZSCFI',
                  name: 'NZ Science Fiction',
                },
                {
                  code: 'NZSHOR',
                  name: 'NZ Short Stories',
                },
                {
                  code: 'NZTRAV',
                  name: 'NZ Travel',
                },
              ],
            },
            {
              name: 'CLASSIC FICTION',
              ebilityCategories: [
                {
                  code: 'CLAFIC',
                  name: 'Classic Fiction',
                },
              ],
            },
            {
              name: 'POETRY',
              ebilityCategories: [
                {
                  code: 'CARPOE',
                  name: 'Carribean Poetry',
                },
                {
                  code: 'LESPOE',
                  name: 'Lesbian Poetry',
                },
                {
                  code: 'LOVPOE',
                  name: 'Love Poetry',
                },
                {
                  code: 'PACPOE',
                  name: 'Pacifica Poet',
                },
                {
                  code: 'POETRY',
                  name: 'Poetry',
                },
                {
                  code: 'QUEPOE',
                  name: 'Queer Poetry',
                },
                {
                  code: 'NZPOET',
                  name: 'NZ Poetry',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ POETRY',
              ebilityCategories: [
                {
                  code: 'NZPOET',
                  name: 'NZ Poetry',
                },
              ],
            },
            {
              name: 'CRIME FICTION',
              ebilityCategories: [
                {
                  code: 'POLTHR',
                  name: 'Political thriller',
                },
                {
                  code: 'SCACRI',
                  name: 'Scandinavian Crime',
                },
                {
                  code: 'SPYFIC',
                  name: 'Espionage Fiction',
                },
                {
                  code: 'SWECRI',
                  name: 'Swedish Crime',
                },
                {
                  code: 'CRIME',
                  name: 'Crime fiction',
                },
                {
                  code: 'NZCRIM',
                  name: 'NZ Crime Fiction',
                },
                {
                  code: 'THRILL',
                  name: 'Thriller',
                },
                {
                  code: 'CRIANT',
                  name: 'Crime Anthologies',
                },
                {
                  code: 'CRICLA',
                  name: 'Crime Classics',
                },
                {
                  code: 'CRIGAY',
                  name: 'Gay Crime',
                },
                {
                  code: 'CRIREF',
                  name: 'Crime Reference',
                },
                {
                  code: 'CRISHO',
                  name: 'Crime Short Stories',
                },
                {
                  code: 'MYSTER',
                  name: 'Mystery',
                },
                {
                  code: 'NZCRIF',
                  name: 'NZ Crime Fiction',
                },
                {
                  code: 'SCACRI',
                  name: 'Scandinavian Crime',
                },
                {
                  code: 'SPYFIC',
                  name: 'Espionage Fiction',
                },
              ],
            },
            {
              name: 'SCIENCE FICTION & FANTASY',
              ebilityCategories: [
                {
                  code: 'FANTAS',
                  name: 'Fantasy',
                },
                {
                  code: 'HORROR',
                  name: 'Horror',
                },
                {
                  code: 'NZFANT',
                  name: 'Horror',
                },
                {
                  code: 'NZSCFI',
                  name: 'NZ Science Fiction',
                },
                {
                  code: 'SCIFIC',
                  name: 'Science Fiction',
                },
                {
                  code: 'NZSF',
                  name: 'NZ Science Fiction',
                },
              ],
            },
            {
              name: 'GRAPHIC NOVELS',
              ebilityCategories: [
                {
                  code: 'GRANOV',
                  name: 'Graphic Novel',
                },
                {
                  code: 'MANGA',
                  name: 'Manga',
                },
                {
                  code: 'COMICS',
                  name: 'Comics',
                },
              ],
            },
          ],
        },
      ],
    },
  },
  {
    webDepartment: {
      name: 'CHILDREN & YOUNG ADULT',
      mainCategories: [
        {
          name: 'CHILDREN & YOUNG ADULT',
          subCategories: [
            {
              name: 'GRAPHIC NOVELS FOR CHILDREN & YOUNG ADULT',
              ebilityCategories: [
                {
                  code: 'KIDGRA',
                  name: 'Kids Graphic Novels',
                },
                {
                  code: 'KNZTRE',
                  name: 'NZ Kids Treasury',
                },
                {
                  code: 'KPASIF',
                  name: 'Kids Pasifika books',
                },
                {
                  code: 'KIDANT',
                  name: 'Childrens Anthology',
                },
                {
                  code: 'KIXMAS',
                  name: 'Kids Christmas',
                },
                {
                  code: 'LIFTFL',
                  name: 'Lift The Flap',
                },
              ],
            },
            {
              name: 'CHILDREN & YOUNG ADULT',
              ebilityCategories: [
                {
                  code: 'CLOTHB',
                  name: 'Cloth books (kids)',
                },
                {
                  code: 'BOXSET',
                  name: 'Kids Boxset',
                },
                {
                  code: 'KBILIN',
                  name: 'Kids Bilingual',
                },
                {
                  code: 'KIDGIF',
                  name: 'Kid Gift Books',
                },
                {
                  code: 'KIDPOE',
                  name: 'Childrens Poetry',
                },
                {
                  code: 'KIDX',
                  name: 'Kids Christmas',
                },
                {
                  code: 'NOVELT',
                  name: 'Kids Novelty',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ PICTURE BOOKS',
              ebilityCategories: [
                {
                  code: 'NZBOAR',
                  name: 'NZ Board Book',
                },
                {
                  code: 'NZHBPI',
                  name: 'NZ HB Kids Pic Books',
                },
                {
                  code: 'NZPICB',
                  name: 'NZ Picture Book',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ JUNIOR FICTION',
              ebilityCategories: [
                {
                  code: 'NZJUNI',
                  name: 'NZ Junior Fiction',
                },
                {
                  code: 'NZJUNF',
                  name: 'NZJunior Fiction 4-8',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ MIDDLE FICTION',
              ebilityCategories: [
                {
                  code: 'NZKIDM',
                  name: 'NZMiddleReaders 9-12',
                },
                {
                  code: 'NZMIDF',
                  name: 'NZ MiddleReaders 9-12',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ YOUNG ADULT FICTION',
              ebilityCategories: [
                {
                  code: 'NZTEEN',
                  name: 'NZ Teen Fiction',
                },
                {
                  code: 'NZYAF',
                  name: 'NZ Teen Fiction',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ CHILDRENS NONFICTION',
              ebilityCategories: [
                {
                  code: 'NZKIDA',
                  name: 'NZ Kids Art',
                },
                {
                  code: 'NZKIDN',
                  name: 'NZ Kids NonFiction',
                },
                {
                  code: 'KIDISS',
                  name: 'Kids Issues',
                },
              ],
            },
            {
              name: 'CHILDREN & YOUNG ADULT BOOKS IN TE REO MAORI',
              ebilityCategories: [
                {
                  code: 'MAOKID',
                  name: 'Maori Kids Books',
                },
              ],
            },
            {
              name: 'BOARD BOOKS',
              ebilityCategories: [
                {
                  code: 'NZBOAR',
                  name: 'NZ Board Book',
                },
                {
                  code: 'BOARDB',
                  name: 'Board Books',
                },
                {
                  code: 'CLABOA',
                  name: 'Classic Board Books',
                },
              ],
            },
            {
              name: 'PICTURE BOOKS',
              ebilityCategories: [
                {
                  code: 'PICBOO',
                  name: 'Picture Books',
                },
                {
                  code: 'QUEPIC',
                  name: 'Queer Picture Book',
                },
                {
                  code: 'CLAPIC',
                  name: 'CLASSIC PICTURE BOOK',
                },
                {
                  code: 'HBPICB',
                  name: 'HB Kids Picture Book',
                },
                {
                  code: 'CLAPIC',
                  name: 'CLASSIC PICTURE BOOK',
                },
              ],
            },
            {
              name: 'JUNIOR FICTION',
              ebilityCategories: [
                {
                  code: 'QUEJUN',
                  name: 'Queer Junior Fiction',
                },
                {
                  code: 'JUNFIC',
                  name: 'Junior Fiction (4-9)',
                },
                {
                  code: 'KID1ST',
                  name: 'kid first readers',
                },
              ],
            },
            {
              name: 'MIDDLE FICTION',
              ebilityCategories: [
                {
                  code: 'QUEMID',
                  name: 'Queer Middle Readers',
                },
                {
                  code: 'KIDMID',
                  name: 'Middle Readers 9-12',
                },
                {
                  code: 'MIDFIC',
                  name: 'Middle Readers 9-12',
                },
              ],
            },
            {
              name: 'YOUNG ADULT FICTION',
              ebilityCategories: [
                {
                  code: 'QUETEE',
                  name: 'Queer Teen Fiction',
                },
                {
                  code: 'TEEFIC',
                  name: 'Teen Fiction',
                },
                {
                  code: 'TEESHO',
                  name: 'Teen Short Stories',
                },
                {
                  code: 'YAFIC',
                  name: 'Teen Fiction',
                },
              ],
            },
            {
              name: 'CHILDRENS NONFICTION',
              ebilityCategories: [
                {
                  code: 'TEENON',
                  name: 'Teenage Nonfiction',
                },
                {
                  code: 'ACTBOO',
                  name: 'Activity Books',
                },
                {
                  code: 'ACTIVI',
                  name: 'Activity',
                },
                {
                  code: 'COUNTI',
                  name: 'Counting (Kids)',
                },
                {
                  code: 'KIDART',
                  name: 'Childrens Art',
                },
                {
                  code: 'KIDBIO',
                  name: 'Kids Biography',
                },
                {
                  code: 'KIDCOO',
                  name: 'Kids Cookbook',
                },
                {
                  code: 'KIDMYT',
                  name: 'Children Myth, Legends',
                },
                {
                  code: 'KIDMYT',
                  name: 'Children Myth, Legends',
                },
                {
                  code: 'KIDNON',
                  name: 'Childrens Nonfiction',
                },
                {
                  code: 'KNACTI',
                  name: 'Kids Activity',
                },
                {
                  code: 'KNARTS',
                  name: 'Kids Arts',
                },
                {
                  code: 'KNBIOG',
                  name: 'Kids Biography',
                },
                {
                  code: 'KNEDUC',
                  name: 'Kids educational',
                },
                {
                  code: 'KNHIST',
                  name: 'Kids history',
                },
                {
                  code: 'KNNATU',
                  name: 'Kids Natural World',
                },
                {
                  code: 'KNSCI',
                  name: 'Kids Science',
                },
                {
                  code: 'KNSPOR',
                  name: 'Kids sports',
                },
                {
                  code: 'YANON',
                  name: 'Teenage Nonfiction',
                },
              ],
            },
            {
              name: 'CHILDRENS CLASSICS',
              ebilityCategories: [
                {
                  code: 'KIDCLA',
                  name: 'Childrens Classics',
                },
                {
                  code: 'KIDLIT',
                  name: 'Childrens Literature',
                },
                {
                  code: 'NURRHY',
                  name: 'Nursery Rhymes',
                },
              ],
            },
            {
              name: 'LGBTQIA+ CHILDREN & YOUNG ADULT',
              ebilityCategories: [
                {
                  code: 'QUEJUN',
                  name: 'Queer Junior Fiction',
                },
                {
                  code: 'QUEMID',
                  name: 'Queer Middle Readers',
                },
                {
                  code: 'QUEPIC',
                  name: 'Queer Picture Book',
                },
                {
                  code: 'QUETEE',
                  name: 'Queer Teen Fiction',
                },
              ],
            },
          ],
        },
      ],
    },
  },
  {
    webDepartment: {
      name: 'NON FICTION',
      mainCategories: [
        {
          name: 'NON FICTION',
          subCategories: [
            {
              name: 'NON FICTION',
              ebilityCategories: [
                {
                  code: 'WESTER',
                  name: 'Westerns',
                },
                {
                  code: 'FUTURE',
                  name: 'The Future',
                },
                {
                  code: 'WHISKY',
                  name: 'Whisky',
                },
                {
                  code: 'BEAT',
                  name: 'Beat Movement',
                },
                {
                  code: 'WELLIN',
                  name: 'Wellington',
                },
                {
                  code: 'UNIONS',
                  name: 'Trade Unions',
                },
                {
                  code: 'TIME',
                  name: 'Time',
                },
                {
                  code: 'THEORY',
                  name: 'Theory',
                },
                {
                  code: 'TERROR',
                  name: 'Terrorism',
                },
                {
                  code: 'TEACHI',
                  name: 'Teaching',
                },
                {
                  code: 'SYMBOL',
                  name: 'Symbols',
                },
                {
                  code: 'SUSTAI',
                  name: 'Sustainability',
                },
                {
                  code: 'SURVIV',
                  name: 'Survival Skills',
                },
                {
                  code: 'SURREA',
                  name: 'Surrealism',
                },
                {
                  code: 'SUPVIL',
                  name: 'Supervillains',
                },
                {
                  code: 'STAWAR',
                  name: 'Star Wars',
                },
                {
                  code: 'SOAP',
                  name: 'Soap Making',
                },
                {
                  code: 'SELFSU',
                  name: 'Self Sufficiency',
                },
                {
                  code: 'REVIEW',
                  name: 'Reviews',
                },
                {
                  code: 'REAEST',
                  name: 'Real Estate',
                },
                {
                  code: 'READIN',
                  name: 'Reading',
                },
                {
                  code: 'RADIO',
                  name: 'Radio Performances',
                },
                {
                  code: 'PERSON',
                  name: 'Personality Types',
                },
                {
                  code: 'NZZINE',
                  name: 'NZ Zine',
                },
                {
                  code: 'NOBEL',
                  name: 'Nobel Prize Winner',
                },
                {
                  code: 'POISON',
                  name: 'Poison',
                },
                {
                  code: 'MISCEL',
                  name: 'Miscellany',
                },
                {
                  code: 'MONOGR',
                  name: 'Monographs',
                },
                {
                  code: 'MINING',
                  name: 'Mining',
                },
                {
                  code: 'MAKMOD',
                  name: 'Making Models',
                },
                {
                  code: 'MAGIC',
                  name: 'Magic',
                },
                {
                  code: 'LOVE',
                  name: 'Love',
                },
                {
                  code: 'IRAN',
                  name: 'Iran',
                },
                {
                  code: 'INTERV',
                  name: 'Interviews',
                },
                {
                  code: 'INSPIR',
                  name: 'Inspirational',
                },
                {
                  code: 'INEQUA',
                  name: 'Inequality',
                },
                {
                  code: 'INDIGE',
                  name: 'Indigenous People',
                },
                {
                  code: 'IDENTI',
                  name: 'Identity',
                },
                {
                  code: 'HALLOW',
                  name: 'Halloween',
                },
                {
                  code: 'GOTHIC',
                  name: 'Gothic',
                },
                {
                  code: 'GENEAL',
                  name: 'Genealogy',
                },
                {
                  code: 'FLATTI',
                  name: 'Flatting Survival',
                },
                {
                  code: 'FILTIE',
                  name: 'Film Tie in',
                },
                {
                  code: 'EMPLOY',
                  name: 'Employment',
                },
                {
                  code: 'DRUGS',
                  name: 'Drugs',
                },
                {
                  code: 'DREAMS',
                  name: 'Dreams',
                },
                {
                  code: 'DIVINA',
                  name: 'Divination',
                },
                {
                  code: 'DISABI',
                  name: 'Disability Issues',
                },
                {
                  code: 'DECOLO',
                  name: 'Decolonization',
                },
                {
                  code: 'CREATI',
                  name: 'Creativity',
                },
                {
                  code: 'COMMUN',
                  name: 'Communication',
                },
                {
                  code: 'COLLWO',
                  name: 'Collected Works',
                },
                {
                  code: 'CLEANI',
                  name: 'Scrubbing',
                },
                {
                  code: 'CHCH',
                  name: 'Christchurch',
                },
                {
                  code: 'CENAME',
                  name: 'Central America',
                },
                {
                  code: 'CARTOG',
                  name: 'Cartography',
                },
                {
                  code: 'CAPCOO',
                  name: 'Captain Cook',
                },
                {
                  code: 'BUILDI',
                  name: 'Building',
                },
                {
                  code: 'ANTARC',
                  name: 'Antarctica',
                },
                {
                  code: 'AGRICU',
                  name: 'Agriculture',
                },
                {
                  code: 'ARCTIC',
                  name: 'Arctic',
                },
                {
                  code: 'DIGITA',
                  name: 'All things Digital',
                },
                {
                  code: 'EDUCAT',
                  name: 'Education',
                },
                {
                  code: 'GIFBOO',
                  name: 'Gift Books',
                },
                {
                  code: 'GIFTBO',
                  name: 'Gift Book',
                },
                {
                  code: 'IDEAS',
                  name: 'Ideas',
                },
                {
                  code: 'INFORM',
                  name: 'Information',
                },
                {
                  code: 'PACIFI',
                  name: 'Pacific Islands',
                },
                {
                  code: 'POPUP',
                  name: 'Pop-Up',
                },
                {
                  code: 'UFOS',
                  name: 'UFOs',
                },
              ],
            },
          ],
        },
        {
          name: 'BIOGRAPHY & MEMOIR',
          subCategories: [
            {
              name: 'BIOGRAPHY & MEMOIR',
              ebilityCategories: [
                {
                  code: 'BIOGRA',
                  name: 'Biography',
                },
                {
                  code: 'MEMOIR',
                  name: 'Memoirs',
                },
                {
                  code: 'AFRBIO',
                  name: 'African Biography',
                },
                {
                  code: 'AMEBIO',
                  name: 'American Biography',
                },
                {
                  code: 'AUSBIO',
                  name: 'Australian Biography',
                },
                {
                  code: 'AUTOBI',
                  name: 'Autobiography',
                },
                {
                  code: 'BRIBIO',
                  name: 'British Biography',
                },
                {
                  code: 'CHIBIO',
                  name: 'Chinese Biography',
                },
                {
                  code: 'FREBIO',
                  name: 'French biography',
                },
                {
                  code: 'IRIBIO',
                  name: 'Irish Biography',
                },
                {
                  code: 'JEWBIO',
                  name: 'Jewish Biography',
                },
                {
                  code: 'MEXBIO',
                  name: 'Mexican Biography',
                },
                {
                  code: 'POLIBI',
                  name: 'Polish Biography',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ BIOGRAPHY',
              ebilityCategories: [
                {
                  code: 'MAOBIO',
                  name: 'Maori Biography',
                },
                {
                  code: 'NZBIOG',
                  name: 'NZ Biography',
                },
                {
                  code: 'NZMEMO',
                  name: 'NZ Memoir',
                },
              ],
            },
            {
              name: 'HISTORICAL BIOGRAPHY',
              ebilityCategories: [
                {
                  code: 'HISBIO',
                  name: 'Historical Biography',
                },
                {
                  code: 'WW1BIO',
                  name: 'World War 1 Biography',
                },
                {
                  code: 'WW2BIO',
                  name: 'World War 2 Biography',
                },
              ],
            },
            {
              name: 'LITERARY BIOGRAPHY',
              ebilityCategories: [
                {
                  code: 'LITBIO',
                  name: 'Literary Biography',
                },
                {
                  code: 'POEBIO',
                  name: 'Poet Biography',
                },
              ],
            },
            {
              name: 'POLITICAL BIOGRAPHY',
              ebilityCategories: [
                {
                  code: 'POLBIO',
                  name: 'Political Biography',
                },
              ],
            },
          ],
        },
        {
          name: 'TRAVEL',
          subCategories: [
            {
              name: 'TRAVEL',
              ebilityCategories: [
                {
                  code: 'MAPS',
                  name: 'Maps',
                },
                {
                  code: 'ADVENT',
                  name: 'Adventure (True)',
                },
                {
                  code: 'WORTRA',
                  name: 'World Travel',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ TRAVEL',
              ebilityCategories: [
                {
                  code: 'ROADCO',
                  name: 'NZ Road Code',
                },
                {
                  code: 'KIWIAN',
                  name: 'Kiwiana',
                },
                {
                  code: 'NZPICT',
                  name: 'NZ Pictorial',
                },
                {
                  code: 'NZTRAV',
                  name: 'NZ Travel',
                },
              ],
            },
            {
              name: 'TRAVEL GUIDES',
              ebilityCategories: [
                {
                  code: 'AFRTRA',
                  name: 'Africa Travel',
                },
                {
                  code: 'AUSTRA',
                  name: 'Australasia Travel',
                },
                {
                  code: 'ASITRA',
                  name: 'Asia Travel',
                },
                {
                  code: 'EURTRA',
                  name: 'Europe Travel',
                },
                {
                  code: 'IRITRA',
                  name: 'Irish Travel',
                },
                {
                  code: 'NOATRA',
                  name: 'North America Travel',
                },
                {
                  code: 'SOATRA',
                  name: 'South America Travel',
                },
                {
                  code: 'TRAGUI',
                  name: 'Travel Guide',
                },
                {
                  code: 'TRAPHO',
                  name: 'Travel Photography',
                },
                {
                  code: 'TRAVPI',
                  name: 'Travel Pictorial',
                },
              ],
            },
            {
              name: 'TRAVEL WRITING',
              ebilityCategories: [
                {
                  code: 'TRAHIS',
                  name: 'Travel History',
                },
                {
                  code: 'TRAWRI',
                  name: 'Travel Writing',
                },
              ],
            },
          ],
        },
        {
          name: 'THE ARTS',
          subCategories: [
            {
              name: 'THE ARTS',
              ebilityCategories: [
                {
                  code: 'MUSEUM',
                  name: 'Museums',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ ART',
              ebilityCategories: [
                {
                  code: 'MAOART',
                  name: 'Maori Art',
                },
                {
                  code: 'NZARCH',
                  name: 'NZ Architecture',
                },
                {
                  code: 'NZART',
                  name: 'NZ Art',
                },
                {
                  code: 'NZDESI',
                  name: 'NZ Design',
                },
                {
                  code: 'NZPHOT',
                  name: 'NZ Photography',
                },
              ],
            },
            {
              name: 'ARCHITECTURE',
              ebilityCategories: [
                {
                  code: 'NZARCH',
                  name: 'NZ Architecture',
                },
                {
                  code: 'SUSARC',
                  name: 'Sustainable Architec',
                },
                {
                  code: 'URBDES',
                  name: 'Urban Design',
                },
                {
                  code: 'URBPLA',
                  name: 'Urban Planning',
                },
                {
                  code: 'HOMDES',
                  name: 'Home Design',
                },
                {
                  code: 'INTDES',
                  name: 'Interior Design',
                },
                {
                  code: 'LANARC',
                  name: 'Landscape Architectu',
                },
                {
                  code: 'ARCHIT',
                  name: 'Architecture',
                },
              ],
            },
            {
              name: 'ART',
              ebilityCategories: [
                {
                  code: 'ART',
                  name: 'Art',
                },
                {
                  code: 'ARTHIS',
                  name: 'Art History',
                },
                {
                  code: 'ARTTHE',
                  name: 'Art Theory',
                },
                {
                  code: 'CERAMI',
                  name: 'Ceramics',
                },
                {
                  code: 'NZART',
                  name: 'NZ Art',
                },
                {
                  code: 'PERART',
                  name: 'Performance Art',
                },
                {
                  code: 'POLART',
                  name: 'Political Art',
                },
                {
                  code: 'QUEART',
                  name: 'Queer Art',
                },
                {
                  code: 'RELART',
                  name: 'Religious Art',
                },
                {
                  code: 'RENART',
                  name: 'Renaissance Art',
                },
                {
                  code: 'SCULPT',
                  name: 'Sculpture',
                },
                {
                  code: 'SPAART',
                  name: 'Spanish Art',
                },
                {
                  code: 'STRART',
                  name: 'Street Art',
                },
                {
                  code: 'ARTABS',
                  name: 'Abstract Art',
                },
                {
                  code: 'ARTANT',
                  name: 'Art Anthologies',
                },
                {
                  code: 'ARTBIO',
                  name: 'Art Biography',
                },
                {
                  code: 'ARTCAT',
                  name: 'Art Catalogue',
                },
                {
                  code: 'ARTCOL',
                  name: 'Art Collecting',
                },
                {
                  code: 'ARTCRI',
                  name: 'Art Criticism',
                },
                {
                  code: 'ARTHIS',
                  name: 'Art History',
                },
                {
                  code: 'ARTIST',
                  name: 'Artists',
                },
                {
                  code: 'BRIART',
                  name: 'British Art',
                },
                {
                  code: 'CELART',
                  name: 'Celtic Art',
                },
                {
                  code: 'CHIART',
                  name: 'Chinese art',
                },
                {
                  code: 'CONART',
                  name: 'Contemporary Art',
                },
                {
                  code: 'CURATI',
                  name: 'Curating',
                },
                {
                  code: 'EROART',
                  name: 'Erotic Art',
                },
                {
                  code: 'FANART',
                  name: 'Fantasy Art',
                },
                {
                  code: 'FEMART',
                  name: 'Feminist Art',
                },
                {
                  code: 'FREART',
                  name: 'French Art',
                },
                {
                  code: 'GAYART',
                  name: 'Gay Art',
                },
                {
                  code: 'GENART',
                  name: 'General Art',
                },
                {
                  code: 'IMPRES',
                  name: 'Impressionism',
                },
                {
                  code: 'INDART',
                  name: 'Indian Art',
                },
                {
                  code: 'JAPART',
                  name: 'Japanese Art',
                },
                {
                  code: 'MEXART',
                  name: 'Mexican Art',
                },
                {
                  code: 'MODART',
                  name: 'Modern Art',
                },
                {
                  code: 'PACART',
                  name: 'Pacific Art',
                },
                {
                  code: 'PAINTI',
                  name: 'Painting',
                },
                {
                  code: 'AUSART',
                  name: 'Australian Art',
                },
              ],
            },
            {
              name: 'DESIGN & CRAFT',
              ebilityCategories: [
                {
                  code: 'CRAFT',
                  name: 'Craft',
                },
                {
                  code: 'SEWING',
                  name: 'Sewing',
                },
                {
                  code: 'TATTOO',
                  name: 'Tattoo',
                },
                {
                  code: 'TAXIDE',
                  name: 'Taxidermy',
                },
                {
                  code: 'TEXTIL',
                  name: 'Textile',
                },
                {
                  code: 'TYPOGR',
                  name: 'Typography',
                },
                {
                  code: 'WEBDES',
                  name: 'Web Design',
                },
                {
                  code: 'WOOCRA',
                  name: 'Woodcraft',
                },
                {
                  code: 'ANIMAT',
                  name: 'Animation',
                },
                {
                  code: 'ANTIQU',
                  name: 'Antiques',
                },
                {
                  code: 'ARTCRA',
                  name: 'Art Craft (All)',
                },
                {
                  code: 'ARTDEC',
                  name: 'Art Deco',
                },
                {
                  code: 'ARTPRA',
                  name: 'Practical Art',
                },
                {
                  code: 'BOODES',
                  name: 'Book Design',
                },
                {
                  code: 'COLLEC',
                  name: 'Collectibles',
                },
                {
                  code: 'COLOUG',
                  name: 'Colouring',
                },
                {
                  code: 'COLOUR',
                  name: 'Colour',
                },
                {
                  code: 'CROCHE',
                  name: 'Crochet',
                },
                {
                  code: 'DESIGN',
                  name: 'Design',
                },
                {
                  code: 'DIGDES',
                  name: 'Digital Art/Design',
                },
                {
                  code: 'DIY',
                  name: 'DIY',
                },
                {
                  code: 'DRAWIN',
                  name: 'Drawing',
                },
                {
                  code: 'FURNIT',
                  name: 'Furniture',
                },
                {
                  code: 'GRADES',
                  name: 'Graphic Design',
                },
                {
                  code: 'ILLUST',
                  name: 'Illustrations',
                },
                {
                  code: 'INDDES',
                  name: 'Industrial Design',
                },
                {
                  code: 'JEWELL',
                  name: 'Jewellery',
                },
                {
                  code: 'KNITTI',
                  name: 'Knitting',
                },
                {
                  code: 'KNOTS',
                  name: 'Knots',
                },
                {
                  code: 'MODERN',
                  name: 'Modernism',
                },
                {
                  code: 'NZDESI',
                  name: 'NZ Design',
                },
                {
                  code: 'POTTER',
                  name: 'Pottery',
                },
                {
                  code: 'PAPCRA',
                  name: 'Paper craft',
                },
                {
                  code: 'PRINTI',
                  name: 'Printing',
                },
                {
                  code: 'PRINTM',
                  name: 'Printmaking',
                },
                {
                  code: 'QUILT',
                  name: 'Quilting',
                },
                {
                  code: 'SCRPRI',
                  name: 'Screen Printing',
                },
                {
                  code: 'QUILT',
                  name: 'Quilting',
                },
              ],
            },
            {
              name: 'FASHION',
              ebilityCategories: [
                {
                  code: 'COSMET',
                  name: 'Cosmetics',
                },
                {
                  code: 'FASBIO',
                  name: 'Fashion Biography',
                },
                {
                  code: 'FASHIO',
                  name: 'Fashion',
                },
                {
                  code: 'NZFASH',
                  name: 'NZ Fashion',
                },
                {
                  code: 'PERFUM',
                  name: 'Perfume',
                },
                {
                  code: 'SHOES',
                  name: 'shoes',
                },
              ],
            },
            {
              name: 'FILM & TELEVISION',
              ebilityCategories: [
                {
                  code: 'ACTING',
                  name: 'Acting',
                },
                {
                  code: 'ACTBIO',
                  name: 'Actor Biography',
                },
                {
                  code: 'BROADC',
                  name: 'Broadcasting',
                },
                {
                  code: 'COMBIO',
                  name: 'Comedian Bio',
                },
                {
                  code: 'DIRECT',
                  name: 'Directing',
                },
                {
                  code: 'FILART',
                  name: 'Film Art',
                },
                {
                  code: 'FILBIO',
                  name: 'Film Bio',
                },
                {
                  code: 'FILHIS',
                  name: 'Film History',
                },
                {
                  code: 'FILCRI',
                  name: 'Film Crime',
                },
                {
                  code: 'FILDOC',
                  name: 'Documentary Film',
                },
                {
                  code: 'FILM',
                  name: 'Film',
                },
                {
                  code: 'SCRWRI',
                  name: 'Script Writing',
                },
                {
                  code: 'TELEVI',
                  name: 'Television',
                },
                {
                  code: 'FILMCR',
                  name: 'Film Criticism',
                },
                {
                  code: 'FILMGU',
                  name: 'Film Guides',
                },
                {
                  code: 'FILMMU',
                  name: 'Film Musicals',
                },
                {
                  code: 'FILMUS',
                  name: 'Film Music',
                },
                {
                  code: 'FILPRO',
                  name: 'Film Production',
                },
                {
                  code: 'FILTHE',
                  name: 'Film Theory',
                },
                {
                  code: 'HORFIL',
                  name: 'Horror Films',
                },
                {
                  code: 'NZFILM',
                  name: 'NZ Film',
                },
                {
                  code: 'SCREEN',
                  name: 'Screenplays',
                },
                {
                  code: 'SCRWRI',
                  name: 'Script Writing',
                },
              ],
            },
            {
              name: 'MUSIC',
              ebilityCategories: [
                {
                  code: 'MUSIND',
                  name: 'Music Industry',
                },
                {
                  code: 'AUSMUS',
                  name: 'Australian Music',
                },
                {
                  code: 'BEATLE',
                  name: 'Beatles',
                },
                {
                  code: 'CLAMUS',
                  name: 'Classical Music',
                },
                {
                  code: 'COMPO',
                  name: 'Composers',
                },
                {
                  code: 'COUMUS',
                  name: 'Country Music',
                },
                {
                  code: 'ELEMUS',
                  name: 'Electronic Music',
                },
                {
                  code: 'FILMMU',
                  name: 'Film Musicals',
                },
                {
                  code: 'HEAVYM',
                  name: 'Heavy Metal',
                },
                {
                  code: 'FOLKMU',
                  name: 'Folk Music',
                },
                {
                  code: 'HIPHOP',
                  name: 'Hip Hop',
                },
                {
                  code: 'INSTRU',
                  name: 'Instruments',
                },
                {
                  code: 'JAZZ',
                  name: 'Jazz',
                },
                {
                  code: 'MAOMUS',
                  name: 'Maori Music',
                },
                {
                  code: 'MUSALT',
                  name: 'Alternative Music',
                },
                {
                  code: 'MUSART',
                  name: 'Music Art',
                },
                {
                  code: 'MUSBIO',
                  name: 'Music Biography',
                },
                {
                  code: 'MUSHIS',
                  name: 'Music History',
                },
                {
                  code: 'MUSIC',
                  name: 'Music',
                },
                {
                  code: 'MUSICA',
                  name: 'Musicals',
                },
                {
                  code: 'MUSINS',
                  name: 'Musical Instuments',
                },
                {
                  code: 'MUSPHO',
                  name: 'Music Photography',
                },
                {
                  code: 'MUSREF',
                  name: 'Music Writing/Reference',
                },
                {
                  code: 'NZMUSI',
                  name: 'NZ Music',
                },
                {
                  code: 'OPERA',
                  name: 'Opera',
                },
                {
                  code: 'POPMUS',
                  name: 'Pop Music',
                },
                {
                  code: 'PUNK',
                  name: 'Punk Rock',
                },
                {
                  code: 'ROCMUS',
                  name: 'Rock Music',
                },
                {
                  code: 'SONGWR',
                  name: 'Songwriting',
                },
                {
                  code: 'ROCPOP',
                  name: 'Rock & Pop',
                },
              ],
            },
            {
              name: 'PHOTOGRAPHY',
              ebilityCategories: [
                {
                  code: 'MUSPHO',
                  name: 'Music Photography',
                },
                {
                  code: 'NZPHOT',
                  name: 'NZ Photography',
                },
                {
                  code: 'PHOTOG',
                  name: 'Photography',
                },
                {
                  code: 'QUEPHO',
                  name: 'Queer Photography',
                },
                {
                  code: 'TRAPHO',
                  name: 'Travel Photography',
                },
                {
                  code: 'TRAVPI',
                  name: 'Travel Pictorial',
                },
              ],
            },
            {
              name: 'THEATRE',
              ebilityCategories: [
                {
                  code: 'ACTING',
                  name: 'Acting',
                },
                {
                  code: 'DANCE',
                  name: 'Dance',
                },
                {
                  code: 'MUSICA',
                  name: 'Musicals',
                },
                {
                  code: 'NZPLAY',
                  name: 'NZ Plays',
                },
                {
                  code: 'PLAYS',
                  name: 'Plays',
                },
                {
                  code: 'SHAKES',
                  name: 'Shakespeare',
                },
                {
                  code: 'THEATR',
                  name: 'Theatre',
                },
              ],
            },
          ],
        },
        {
          name: 'HISTORY',
          subCategories: [
            {
              name: 'HISTORY',
              ebilityCategories: [
                {
                  code: 'WOMHIS',
                  name: 'Womens History',
                },
                {
                  code: 'SOCHIS',
                  name: 'Social History',
                },
                {
                  code: 'NUCLEA',
                  name: 'Nuclear Issues',
                },
                {
                  code: 'ANTHRO',
                  name: 'Anthropology',
                },
                {
                  code: 'HISTOR',
                  name: 'History',
                },
                {
                  code: 'NAVHIS',
                  name: 'Naval History',
                },
                {
                  code: 'ARCHAE',
                  name: 'Archaeology',
                },
                {
                  code: 'MARHIS',
                  name: 'Maritime History',
                },
                {
                  code: 'MEDHIS',
                  name: 'Medieval History',
                },
              ],
            },
            {
              name: 'AFRICAN HISTORY',
              ebilityCategories: [
                {
                  code: 'AFHIS',
                  name: 'African History',
                },
                {
                  code: 'AFRHIS',
                  name: 'African History',
                },
                {
                  code: 'SAFHIS',
                  name: 'Sth African History',
                },
                {
                  code: 'EGYHIS',
                  name: 'Egyptian History',
                },
              ],
            },
            {
              name: 'ANCIENT & CLASSICAL HISTORY',
              ebilityCategories: [
                {
                  code: 'ANCHIS',
                  name: 'Ancient History',
                },
                {
                  code: 'CLAHIS',
                  name: 'Classical History',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ HISTORY',
              ebilityCategories: [
                {
                  code: 'MAOHIS',
                  name: 'Maori History',
                },
                {
                  code: 'NZHIST',
                  name: 'NZ History',
                },
                {
                  code: 'NZMILI',
                  name: 'NZ Military',
                },
                {
                  code: 'NZWAR',
                  name: 'NZ at War',
                },
                {
                  code: 'PARIHA',
                  name: 'Parihaka',
                },
              ],
            },
            {
              name: 'ASIAN HISTORY',
              ebilityCategories: [
                {
                  code: 'ASIHIS',
                  name: 'Asian History',
                },
                {
                  code: 'CHIHIS',
                  name: 'Chinese History',
                },
                {
                  code: 'INDHIS',
                  name: 'Indian History',
                },
                {
                  code: 'JAPHIS',
                  name: 'Japanese History',
                },
                {
                  code: 'KORHIS',
                  name: 'Korean History',
                },
                {
                  code: 'PAKHIS',
                  name: 'Pakistan History',
                },
              ],
            },
            {
              name: 'EUROPEAN HISTORY',
              ebilityCategories: [
                {
                  code: 'BRIHIS',
                  name: 'British History',
                },
                {
                  code: 'DUTHIS',
                  name: 'Dutch History',
                },
                {
                  code: 'ENGHIS',
                  name: 'English History',
                },
                {
                  code: 'EURHIS',
                  name: 'European History',
                },
                {
                  code: 'FREHIS',
                  name: 'French History',
                },
                {
                  code: 'GREHIS',
                  name: 'Greek History',
                },
                {
                  code: 'GYPSIE',
                  name: 'Gypsies',
                },
                {
                  code: 'IRIHIS',
                  name: 'Irish History',
                },
                {
                  code: 'ITAHIS',
                  name: 'Italian History',
                },
                {
                  code: 'RUSHIS',
                  name: 'Russian History',
                },
                {
                  code: 'SCOHIS',
                  name: 'Scottish History',
                },
                {
                  code: 'SPAHIS',
                  name: 'Spanish History',
                },
                {
                  code: 'WELHIS',
                  name: 'Welsh History',
                },
              ],
            },
            {
              name: 'GLOBAL HISTORY',
              ebilityCategories: [
                {
                  code: 'HISTHI',
                  name: 'History Of Things',
                },
                {
                  code: 'JEWHIS',
                  name: 'Jewish History',
                },
                {
                  code: 'WORHIS',
                  name: 'World History',
                },
              ],
            },
            {
              name: 'HISTORY OF THE AMERICAS',
              ebilityCategories: [
                {
                  code: 'MEXHIS',
                  name: 'Mexican History',
                },
                {
                  code: 'SOAHIS',
                  name: 'South American History',
                },
                {
                  code: 'AMEHIS',
                  name: 'American History',
                },
              ],
            },
            {
              name: 'HISTORY OF THE MIDDLE EAST',
              ebilityCategories: [
                {
                  code: 'AFGHIS',
                  name: 'Afghan History',
                },
                {
                  code: 'EGYHIS',
                  name: 'Egyptian History',
                },
                {
                  code: 'MIDHIS',
                  name: 'Middle East History',
                },
                {
                  code: 'PALFIC',
                  name: 'Palestinian Fiction',
                },
              ],
            },
            {
              name: 'MILITARY HISTORY',
              ebilityCategories: [
                {
                  code: 'ANZAC',
                  name: 'ANZAC',
                },
                {
                  code: 'MILBIO',
                  name: 'Military Biography',
                },
                {
                  code: 'MILHIS',
                  name: 'Military History',
                },
                {
                  code: 'MODWAR',
                  name: 'Modern Warfare',
                },
                {
                  code: 'NZMILI',
                  name: 'NZ Military',
                },
                {
                  code: 'NZWAR',
                  name: 'NZ at War',
                },
                {
                  code: 'POWS',
                  name: 'Prisoners of War',
                },
                {
                  code: 'VIEWAR',
                  name: 'Vietnam War',
                },
                {
                  code: 'WARHIS',
                  name: 'War History',
                },
                {
                  code: 'WW1BIO',
                  name: 'World War 1 Biography',
                },
                {
                  code: 'WW1HIS',
                  name: 'World War 1 History',
                },
                {
                  code: 'WW2BIO',
                  name: 'World War 2 Biography',
                },
                {
                  code: 'WW2HIS',
                  name: 'World War 2 History',
                },
                {
                  code: 'ESPION',
                  name: 'Espionage',
                },
              ],
            },
            {
              name: 'OCEANIA HISTORY',
              ebilityCategories: [
                {
                  code: 'AUSHIS',
                  name: 'Australian History',
                },
                {
                  code: 'PACHIS',
                  name: 'Pacific History',
                },
                {
                  code: 'SAMHIS',
                  name: 'Samoan History',
                },
              ],
            },
          ],
        },
        {
          name: 'POLITICS',
          subCategories: [
            {
              name: 'POLITICS',
              ebilityCategories: [
                {
                  code: 'POLHIS',
                  name: 'Political History',
                },
                {
                  code: 'WORPOL',
                  name: 'World Politics',
                },
                {
                  code: 'PROTES',
                  name: 'Protest Politics',
                },
                {
                  code: 'PROTES',
                  name: 'Protest Politics',
                },
                {
                  code: 'POLTHE',
                  name: 'Political Theory',
                },
                {
                  code: 'POLSCI',
                  name: 'Political Science',
                },
                {
                  code: 'POLICY',
                  name: 'Policy',
                },
                {
                  code: 'POLITICS',
                  name: 'Political History',
                },
                {
                  code: 'POLACT',
                  name: 'Political Activism',
                },
                {
                  code: 'MIGRAT',
                  name: 'Migration',
                },
                {
                  code: 'INTPOL',
                  name: 'International Politi',
                },
                {
                  code: 'INTNAT',
                  name: 'International Relati',
                },
                {
                  code: 'IMMIGR',
                  name: 'Immigration',
                },
                {
                  code: 'HUMRIG',
                  name: 'Human Rights',
                },
                {
                  code: 'GOVERN',
                  name: 'Government',
                },
                {
                  code: 'GLOBAL',
                  name: 'Globalisation',
                },
                {
                  code: 'GEOPOL',
                  name: 'Geopolitics',
                },
                {
                  code: 'AUSPOL',
                  name: 'Australian Politics',
                },
                {
                  code: 'MIDPOL',
                  name: 'Middle East Politics',
                },
                {
                  code: 'POLITI',
                  name: 'Politics',
                },
                {
                  code: 'ANARCH',
                  name: 'Anarchism',
                },
                {
                  code: 'CIVRIG',
                  name: 'Civil Rights',
                },
                {
                  code: 'COMISM',
                  name: 'Communism',
                },
                {
                  code: 'DEMOCR',
                  name: 'Democracy',
                },
                {
                  code: 'FORAFF',
                  name: 'Foreign Affairs',
                },
              ],
            },
            {
              name: 'POLITICAL BIOGRAPHY',
              ebilityCategories: [
                {
                  code: 'POLBIO',
                  name: 'Political Biography',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ POLITICS',
              ebilityCategories: [
                {
                  code: 'MAOPOL',
                  name: 'Maori Politics',
                },
                {
                  code: 'NZPOLI',
                  name: 'NZ Politics',
                },
              ],
            },
            {
              name: 'AMERICAN POLITICS',
              ebilityCategories: [
                {
                  code: 'AMEPOL',
                  name: 'American Politics',
                },
              ],
            },
            {
              name: 'EUROPEAN POLITICS',
              ebilityCategories: [
                {
                  code: 'BRIPOL',
                  name: 'British Politics',
                },
                {
                  code: 'EURPOL',
                  name: 'European Politics',
                },
                {
                  code: 'RUSPOL',
                  name: 'Russian Politics',
                },
              ],
            },
            {
              name: 'ASIAN POLITICS',
              ebilityCategories: [
                {
                  code: 'ASIPOL',
                  name: 'Asian Politics',
                },
                {
                  code: 'CHIPOL',
                  name: 'Chinese Politics',
                },
                {
                  code: 'INDPOL',
                  name: 'Indian Politics',
                },
                {
                  code: 'KORPOL',
                  name: 'Korean Politics',
                },
              ],
            },
          ],
        },
        {
          name: 'PHILOSOPHY',
          subCategories: [
            {
              name: 'PHILOSOPHY',
              ebilityCategories: [
                {
                  code: 'ETHICS',
                  name: 'Ethics',
                },
                {
                  code: 'METAPH',
                  name: 'Metaphysics',
                },
                {
                  code: 'PHILOS',
                  name: 'Philosophy',
                },
                {
                  code: 'POLPHI',
                  name: 'Political Philosophy',
                },
              ],
            },
          ],
        },
        {
          name: 'GARDENING',
          subCategories: [
            {
              name: 'GARDENING',
              ebilityCategories: [
                {
                  code: 'GARDEN',
                  name: 'Gardening',
                },
                {
                  code: 'PERMAC',
                  name: 'Permaculture',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ GARDENING',
              ebilityCategories: [
                {
                  code: 'NZGARD',
                  name: 'NZ Gardening',
                },
              ],
            },
          ],
        },
        {
          name: 'FEMINISM',
          subCategories: [
            {
              name: 'FEMINISM',
              ebilityCategories: [
                {
                  code: 'FEMART',
                  name: 'Feminist Art',
                },
                {
                  code: 'FEMFIC',
                  name: 'Feminist Fiction',
                },
                {
                  code: 'FEMHEA',
                  name: 'Feminist Health',
                },
                {
                  code: 'FEMHIS',
                  name: 'Feminist History',
                },
                {
                  code: 'FEMINI',
                  name: 'Feminism',
                },
                {
                  code: 'FEMLIT',
                  name: 'Feminist Literary Criticism',
                },
                {
                  code: 'FEMPOL',
                  name: 'Feminist Politics',
                },
                {
                  code: 'FEMSEX',
                  name: 'Female Sexuality',
                },
                {
                  code: 'GENDER',
                  name: 'Gender Studies',
                },
                {
                  code: 'GENPOL',
                  name: 'Gender Politics',
                },
              ],
            },
          ],
        },
        {
          name: 'SPORT',
          subCategories: [
            {
              name: 'SPORT',
              ebilityCategories: [
                {
                  code: 'FISHIN',
                  name: 'Fishing',
                },
                {
                  code: 'BASEBA',
                  name: 'Baseball',
                },
                {
                  code: 'BASKEB',
                  name: 'Basketball',
                },
                {
                  code: 'BASKET',
                  name: 'Basketball',
                },
                {
                  code: 'BOATIN',
                  name: 'Boating',
                },
                {
                  code: 'BOXING',
                  name: 'Boxing',
                },
                {
                  code: 'CLIMBI',
                  name: 'Climbing',
                },
                {
                  code: 'CRIC',
                  name: 'Cricket',
                },
                {
                  code: 'CRICKE',
                  name: 'Cricket',
                },
                {
                  code: 'CYCL',
                  name: 'Cycling',
                },
                {
                  code: 'CYCLIN',
                  name: 'Cycling',
                },
                {
                  code: 'DIVING',
                  name: 'Diving',
                },
                {
                  code: 'EQUEST',
                  name: 'Equestrian',
                },
                {
                  code: 'FITNES',
                  name: 'Fitness & Exercise',
                },
                {
                  code: 'FOOTBA',
                  name: 'Football',
                },
                {
                  code: 'GOLF',
                  name: 'Golfing',
                },
                {
                  code: 'GYMNAS',
                  name: 'Gymnastics',
                },
                {
                  code: 'HORRAC',
                  name: 'Horse Racing',
                },
                {
                  code: 'HUNTIN',
                  name: 'Hunting',
                },
                {
                  code: 'KAYAKI',
                  name: 'Kayaking',
                },
                {
                  code: 'MARATH',
                  name: 'Marathons',
                },
                {
                  code: 'MARTIA',
                  name: 'Martial Arts',
                },
                {
                  code: 'MOTORS',
                  name: 'Motorsport',
                },
                {
                  code: 'MOUNTA',
                  name: 'Mountaineering',
                },
                {
                  code: 'NZFISH',
                  name: 'NZ Fishing',
                },
                {
                  code: 'NZHUNT',
                  name: 'NZ Hunting',
                },
                {
                  code: 'NZSPOR',
                  name: 'NZ Sport',
                },
                {
                  code: 'OLYMPI',
                  name: 'Olympics',
                },
                {
                  code: 'RACING',
                  name: 'Racing',
                },
                {
                  code: 'RUGBY',
                  name: 'Rugby',
                },
                {
                  code: 'RUNNIN',
                  name: 'Running',
                },
                {
                  code: 'SAILIN',
                  name: 'Sailing',
                },
                {
                  code: 'SHOOT',
                  name: 'Shooting & Guns',
                },
                {
                  code: 'SKATIN',
                  name: 'Skating',
                },
                {
                  code: 'SPOBIO',
                  name: 'Sports Biography',
                },
                {
                  code: 'SPORT',
                  name: 'Sport',
                },
                {
                  code: 'SURFIN',
                  name: 'Surfing',
                },
                {
                  code: 'SWIMMI',
                  name: 'Swimming',
                },
                {
                  code: 'TENNIS',
                  name: 'Tennis',
                },
                {
                  code: 'WOMSPO',
                  name: 'Women`s Sport',
                },
                {
                  code: 'SKATE',
                  name: 'Skateboarding',
                },
                {
                  code: 'SURF',
                  name: 'Surfing',
                },
                {
                  code: 'SWIM',
                  name: 'Swimming',
                },
              ],
            },
          ],
        },
        {
          name: 'TRANSPORT',
          subCategories: [
            {
              name: 'TRANSPORT',
              ebilityCategories: [
                {
                  code: 'AIRPLA',
                  name: 'Airplanes',
                },
                {
                  code: 'AVIATI',
                  name: 'Aviation',
                },
                {
                  code: 'CARS',
                  name: 'Cars',
                },
                {
                  code: 'MOTORC',
                  name: 'Motorcycles',
                },
                {
                  code: 'NZTRAN',
                  name: 'NZ Transport',
                },
                {
                  code: 'TRAINS',
                  name: 'Trains',
                },
                {
                  code: 'TRANSP',
                  name: 'transport',
                },
              ],
            },
          ],
        },
        {
          name: 'LGBTQIA+',
          subCategories: [
            {
              name: 'LGBTQIA+',
              ebilityCategories: [
                {
                  code: 'TRANSG',
                  name: 'Transgender',
                },
                {
                  code: 'LGBTQ+',
                  name: 'LGBTQ+',
                },
                {
                  code: 'LGBTQ',
                  name: 'LGBTQ',
                },
              ],
            },
            {
              name: 'LGBTQIA+ FICTION',
              ebilityCategories: [
                {
                  code: 'CRIGAY',
                  name: 'Gay Crime',
                },
                {
                  code: 'GAYFIC',
                  name: 'Gay Fiction',
                },
                {
                  code: 'GAYPOE',
                  name: 'Gay Poetry',
                },
                {
                  code: 'GAYROM',
                  name: 'Gay Romance',
                },
                {
                  code: 'LESERO',
                  name: 'Lesbian Erotica',
                },
                {
                  code: 'LESFIC',
                  name: 'Lesbian Fiction',
                },
                {
                  code: 'LESPOE',
                  name: 'Lesbian Poetry',
                },
                {
                  code: 'LESROM',
                  name: 'Lesbian Romance',
                },
                {
                  code: 'QUEERO',
                  name: 'Queer Erotica',
                },
                {
                  code: 'QUEFIC',
                  name: 'Queer Fiction',
                },
                {
                  code: 'QUEPOE',
                  name: 'Queer Poetry',
                },
                {
                  code: 'TRAFIC',
                  name: 'Transgender Fiction',
                },
                {
                  code: 'QUEER',
                  name: 'Queer Poetry & Fiction',
                },
              ],
            },
            {
              name: 'LGBTQIA+ NONFICTION',
              ebilityCategories: [
                {
                  code: 'GAYART',
                  name: 'Gay Art',
                },
                {
                  code: 'GAYBIO',
                  name: 'Gay Biography',
                },
                {
                  code: 'GAYERO',
                  name: 'Gay Erotica',
                },
                {
                  code: 'GAYHIS',
                  name: 'Gay History',
                },
                {
                  code: 'GAYMAR',
                  name: 'Same Sex Marriage',
                },
                {
                  code: 'GBLTII',
                  name: 'GBLTI Issues',
                },
                {
                  code: 'LESBIO',
                  name: 'lesbian biography',
                },
                {
                  code: 'LESREF',
                  name: 'Lesbian Reference',
                },
                {
                  code: 'NZGAY',
                  name: 'NZ Gay',
                },
                {
                  code: 'NZQUEE',
                  name: 'NZ Queer',
                },
                {
                  code: 'QUEART',
                  name: 'Queer Art',
                },
                {
                  code: 'QUEBIO',
                  name: 'Queer Biography',
                },
                {
                  code: 'QUECOM',
                  name: 'Queer Comics',
                },
                {
                  code: 'QUECUL',
                  name: 'Queer Culture',
                },
                {
                  code: 'QUEER',
                  name: 'Queer Theory',
                },
                {
                  code: 'QUEESS',
                  name: 'Queer Essays',
                },
                {
                  code: 'QUEHIS',
                  name: 'Queer History',
                },
                {
                  code: 'QUEHUM',
                  name: 'Queer Humour',
                },
                {
                  code: 'QUEPHO',
                  name: 'Queer Photography',
                },
                {
                  code: 'QUEPOL',
                  name: 'Queer Politics',
                },
                {
                  code: 'QUEREF',
                  name: 'Queer Reference',
                },
                {
                  code: 'QUESEX',
                  name: 'Queer Sexuality',
                },
                {
                  code: 'GAYREF',
                  name: 'Gay Reference',
                },
              ],
            },
            {
              name: 'LGBTQIA+ CHILDREN & YOUNG ADULT',
              ebilityCategories: [
                {
                  code: 'QUEJUN',
                  name: 'Queer Junior Fiction',
                },
                {
                  code: 'QUEMID',
                  name: 'Queer Middle Readers',
                },
                {
                  code: 'QUEPIC',
                  name: 'Queer Picture Book',
                },
                {
                  code: 'QUETEE',
                  name: 'Queer Teen Fiction',
                },
              ],
            },
          ],
        },
        {
          name: 'FOOD & DRINK',
          subCategories: [
            {
              name: 'FOOD & DRINK',
              ebilityCategories: [
                {
                  code: 'WORCOO',
                  name: 'World Cooking',
                },
                {
                  code: 'TEA',
                  name: 'Tea',
                },
                {
                  code: 'RESTAU',
                  name: 'Restaurants',
                },
                {
                  code: 'RECIPE',
                  name: 'Recipes',
                },
                {
                  code: 'PRESER',
                  name: 'Preserving',
                },
                {
                  code: 'PERCOO',
                  name: 'Persian Cooking',
                },
                {
                  code: 'MIDCOO',
                  name: 'Middle East Cooking',
                },
                {
                  code: 'MEDITC',
                  name: 'Mediterranean Cookin',
                },
                {
                  code: 'MEAT',
                  name: 'Meat',
                },
                {
                  code: 'KORCOO',
                  name: 'Korean Cooking',
                },
                {
                  code: 'JEWCOO',
                  name: 'Jewish Cooking',
                },
                {
                  code: 'JAPCOO',
                  name: 'Japanese Cooking',
                },
                {
                  code: 'INGRED',
                  name: 'Ingredients',
                },
                {
                  code: 'INDCOO',
                  name: 'Indian Cooking',
                },
                {
                  code: 'HERBAL',
                  name: 'Herbs/Herbalism',
                },
                {
                  code: 'GLUTEN',
                  name: 'Gluten-free cooking',
                },
                {
                  code: 'FERMEN',
                  name: 'Fermentation',
                },
                {
                  code: 'EURCOO',
                  name: 'European Cooking',
                },
                {
                  code: 'CHEESE',
                  name: 'Cheeses',
                },
                {
                  code: 'AMECOO',
                  name: 'American Cooking',
                },
                {
                  code: 'ASICOO',
                  name: 'Asian Cooking',
                },
                {
                  code: 'BRICOO',
                  name: 'British Cooking',
                },
                {
                  code: 'COOKIN',
                  name: 'Cooking',
                },
                {
                  code: 'FRECOO',
                  name: 'French Cooking',
                },
                {
                  code: 'GRECOO',
                  name: 'Greek Cooking',
                },
                {
                  code: 'ITACOO',
                  name: 'Italian Cooking',
                },
                {
                  code: 'MEXCOO',
                  name: 'Mexican Cooking',
                },
                {
                  code: 'SPACOO',
                  name: 'Spanish Cooking',
                },
                {
                  code: 'TURCOO',
                  name: 'Turkish Cooking',
                },
                {
                  code: 'AUSCOO',
                  name: 'Australian Cooking',
                },
                {
                  code: 'CELCHE',
                  name: 'Celebrity Chef',
                },
                {
                  code: 'CHICOO',
                  name: 'Chinese Cooking',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ FOOD & DRINK',
              ebilityCategories: [
                {
                  code: 'NZCOOK',
                  name: 'NZ Cooking',
                },
                {
                  code: 'NZWINE',
                  name: 'NZ Wine',
                },
              ],
            },
            {
              name: 'BAKING & DESSERTS',
              ebilityCategories: [
                {
                  code: 'BAKING',
                  name: 'Baking',
                },
                {
                  code: 'BREAD',
                  name: 'Bread',
                },
                {
                  code: 'DESSER',
                  name: 'Dessert Cookbooks',
                },
                {
                  code: 'PATISS',
                  name: 'Patisserie',
                },
              ],
            },
            {
              name: 'DRINK',
              ebilityCategories: [
                {
                  code: 'WHISKY',
                  name: 'Whisky',
                },
                {
                  code: 'WINE',
                  name: 'Wine',
                },
                {
                  code: 'BEER',
                  name: 'Beer',
                },
              ],
            },
            {
              name: 'DRINKS',
              ebilityCategories: [
                {
                  code: 'DRINKS',
                  name: 'Drinks',
                },
                {
                  code: 'COCKTA',
                  name: 'Cocktails',
                },
                {
                  code: 'COFFEE',
                  name: 'Coffee',
                },
              ],
            },
            {
              name: 'FOOD WRITING',
              ebilityCategories: [
                {
                  code: 'COOBIO',
                  name: 'Cooking biography',
                },
                {
                  code: 'FOOWRI',
                  name: 'Food Writing',
                },
              ],
            },
            {
              name: 'VEGETARIAN & VEGAN',
              ebilityCategories: [
                {
                  code: 'VEGAN',
                  name: 'Veganism',
                },
                {
                  code: 'VEGETA',
                  name: 'Vegetarian',
                },
              ],
            },
          ],
        },
        {
          name: 'REFERENCE',
          subCategories: [
            {
              name: 'REFERENCE',
              ebilityCategories: [
                {
                  code: 'JOURNA',
                  name: 'Journalism',
                },
              ],
            },
          ],
        },
        {
          name: 'ESSAYS & REFERENCE',
          subCategories: [
            {
              name: 'ESSAYS & REFERENCE',
              ebilityCategories: [
                {
                  code: 'REFERE',
                  name: 'Reference',
                },
                {
                  code: 'CEREMO',
                  name: 'Ceremonies',
                },
                {
                  code: 'CRITIC',
                  name: 'Criticism',
                },
                {
                  code: 'ETIQUE',
                  name: 'Etiquette',
                },
                {
                  code: 'PUBSPE',
                  name: 'Public Speaking',
                },
                {
                  code: 'REPORT',
                  name: 'Reportage',
                },
                {
                  code: 'SPEECH',
                  name: 'Speeches',
                },
                {
                  code: 'WOMREF',
                  name: 'Womens Reference',
                },
              ],
            },
            {
              name: 'LANGUAGE & LINGUISTICS',
              ebilityCategories: [
                {
                  code: 'LANGUA',
                  name: 'Language',
                },
                {
                  code: 'ENGLAN',
                  name: 'English Language',
                },
                {
                  code: 'ESOL',
                  name: 'English 2nd Language',
                },
                {
                  code: 'GRAMMA',
                  name: 'Grammar',
                },
              ],
            },
            {
              name: 'DICTIONARIES & ATLASES',
              ebilityCategories: [
                {
                  code: 'THESAU',
                  name: 'Thesaurus',
                },
                {
                  code: 'ATLAS',
                  name: 'Atlas',
                },
                {
                  code: 'DICTIO',
                  name: 'Dictionaries',
                },
                {
                  code: 'ENCYCL',
                  name: 'Encylopedia',
                },
              ],
            },
            {
              name: 'ESSAYS',
              ebilityCategories: [
                {
                  code: 'ESSAYS',
                  name: 'Essays',
                },
                {
                  code: 'LETTER',
                  name: 'Letters',
                },
                {
                  code: 'NZESSA',
                  name: 'NZ Essays',
                },
              ],
            },
            {
              name: 'FOREIGN LANGUAGE',
              ebilityCategories: [
                {
                  code: 'FORLAN',
                  name: 'Foreign Language',
                },
              ],
            },
            {
              name: 'HUMOUR, PUZZLES & GAMES',
              ebilityCategories: [
                {
                  code: 'CARTOO',
                  name: 'Cartoons',
                },
                {
                  code: 'CHESS',
                  name: 'Chess',
                },
                {
                  code: 'GAMES',
                  name: 'Games',
                },
                {
                  code: 'GAMING',
                  name: 'Gaming',
                },
                {
                  code: 'HUMOUR',
                  name: 'Humour',
                },
                {
                  code: 'NZCART',
                  name: 'Nz Cartoons',
                },
                {
                  code: 'NZHUMO',
                  name: 'NZ Humour',
                },
                {
                  code: 'PARODY',
                  name: 'Parody',
                },
                {
                  code: 'POLCAR',
                  name: 'Political Cartoons',
                },
                {
                  code: 'POLSAT',
                  name: 'Political Satire',
                },
                {
                  code: 'PUZZLE',
                  name: 'Puzzle Books',
                },
                {
                  code: 'QUEHUM',
                  name: 'Queer Humour',
                },
                {
                  code: 'QUIZ',
                  name: 'Quiz Book',
                },
                {
                  code: 'SATIRE',
                  name: 'Satire',
                },
                {
                  code: 'TRIVIA',
                  name: 'Trivia',
                },
                {
                  code: 'CROSS',
                  name: 'Crossword Puzzles',
                },
              ],
            },
            {
              name: 'LANGUAGE & LINGUSTICS',
              ebilityCategories: [
                {
                  code: 'SIGLAN',
                  name: 'Sign Language',
                },
                {
                  code: 'SLANG',
                  name: 'Slang',
                },
              ],
            },
            {
              name: 'MYTHS & LEGENDS',
              ebilityCategories: [
                {
                  code: 'FAIRYT',
                  name: 'Fairy Tales',
                },
                {
                  code: 'FOLKTA',
                  name: 'Folk Tales',
                },
                {
                  code: 'HEROES',
                  name: 'Heroes',
                },
                {
                  code: 'MAOMYT',
                  name: 'Maori Myth & Legends',
                },
                {
                  code: 'MYTHOL',
                  name: 'Mythology',
                },
              ],
            },
            {
              name: 'TE REO MAORI',
              ebilityCategories: [
                {
                  code: 'MAOKID',
                  name: 'Maori Kids Books',
                },
                {
                  code: 'TEREO',
                  name: 'Te Reo',
                },
                {
                  code: 'KTEREL',
                  name: 'Kids Te Reo Learning',
                },
                {
                  code: 'KTEREO',
                  name: 'Kids Te Reo Books',
                },
              ],
            },
            {
              name: 'LITERARY CRITICISM, BOOKS & WRITING GUIDES',
              ebilityCategories: [
                {
                  code: 'WRIGUI',
                  name: 'Writing Guides',
                },
                {
                  code: 'BOOCUL',
                  name: 'Book Culture',
                },
                {
                  code: 'BOOKS',
                  name: 'Books',
                },
                {
                  code: 'BOOTRA',
                  name: 'Book Trade',
                },
                {
                  code: 'COPYWR',
                  name: 'Copywriting',
                },
                {
                  code: 'EDITIN',
                  name: 'Editing',
                },
                {
                  code: 'FEMLIT',
                  name: 'Feminist Literary Criticism',
                },
                {
                  code: 'LIBRAR',
                  name: 'Libraries',
                },
                {
                  code: 'LITCRI',
                  name: 'Literary Criticism',
                },
                {
                  code: 'LITHIS',
                  name: 'Literary History',
                },
                {
                  code: 'LITREF',
                  name: 'Literary Reference',
                },
                {
                  code: 'NEWSPA',
                  name: 'Newspapers',
                },
                {
                  code: 'PUBLIS',
                  name: 'Publishing',
                },
                {
                  code: 'QUOTAT',
                  name: 'Quotations',
                },
                {
                  code: 'RESEAR',
                  name: 'Research Methodology',
                },
                {
                  code: 'SCREEN',
                  name: 'Screenplays',
                },
                {
                  code: 'SCRWRI',
                  name: 'Script Writing',
                },
                {
                  code: 'STUGUI',
                  name: 'Study Guides',
                },
              ],
            },
          ],
        },
        {
          name: 'SPIRITUALITY & RELIGION',
          subCategories: [
            {
              name: 'SPIRITUALITY & RELIGION',
              ebilityCategories: [
                {
                  code: 'ASTROL',
                  name: 'Astrology',
                },
                {
                  code: 'OCCULT',
                  name: 'Occult',
                },
                {
                  code: 'RELIGI',
                  name: 'Religion',
                },
                {
                  code: 'SPIRIT',
                  name: 'Spirituality',
                },
                {
                  code: 'TAROT',
                  name: 'Tarot & Oracle Cards',
                },
                {
                  code: 'WITCH',
                  name: 'Witchcraft',
                },
                {
                  code: 'ANGELS',
                  name: 'Angels',
                },
                {
                  code: 'ATHEIS',
                  name: 'Atheism',
                },
                {
                  code: 'BIBHIS',
                  name: 'Bible History',
                },
                {
                  code: 'BIBSTU',
                  name: 'Biblical Studies',
                },
                {
                  code: 'BUDDHI',
                  name: 'Buddhism',
                },
                {
                  code: 'CATHOL',
                  name: 'Catholicism',
                },
                {
                  code: 'CHRIST',
                  name: 'Christian Religion',
                },
                {
                  code: 'HINDUI',
                  name: 'Hinduism',
                },
                {
                  code: 'ISLAM',
                  name: 'Islam',
                },
                {
                  code: 'JUDAIS',
                  name: 'Judaism',
                },
                {
                  code: 'MINDBO',
                  name: 'Mind Body Spirit',
                },
                {
                  code: 'MYSTIC',
                  name: 'Mysticism',
                },
                {
                  code: 'NEWAGE',
                  name: 'New Age Spirituality',
                },
                {
                  code: 'NZSPIR',
                  name: 'NZ Spirituality',
                },
                {
                  code: 'PSYCHC',
                  name: 'Psychics',
                },
                {
                  code: 'RELART',
                  name: 'Religious Art',
                },
                {
                  code: 'RELBIO',
                  name: 'Religious Auto/bio',
                },
                {
                  code: 'SPRBIO',
                  name: 'Spiritual Biography',
                },
                {
                  code: 'TAOISM',
                  name: 'Taoism',
                },
                {
                  code: 'THEOLO',
                  name: 'Theology',
                },
                {
                  code: 'WICCA',
                  name: 'Wicca & Witchcraft',
                },
                {
                  code: 'YOGA',
                  name: 'Yoga',
                },
              ],
            },
            {
              name: 'TAROT & ASTROLOGY',
              ebilityCategories: [
                {
                  code: 'ASTROL',
                  name: 'Astrology',
                },
                {
                  code: 'PSYCHC',
                  name: 'Psychics',
                },
                {
                  code: 'TAROT',
                  name: 'Tarot & Oracle Cards',
                },
              ],
            },
            {
              name: 'YOGA & MEDITATION',
              ebilityCategories: [
                {
                  code: 'MEDITA',
                  name: 'Meditation',
                },
                {
                  code: 'YOGA',
                  name: 'Yoga',
                },
              ],
            },
          ],
        },
        {
          name: 'HEALTH & WELLBEING',
          subCategories: [
            {
              name: 'HEALTH & WELLBEING',
              ebilityCategories: [
                {
                  code: 'WOMHEA',
                  name: 'Womans Health',
                },
                {
                  code: 'SMOKIN',
                  name: 'Smoking',
                },
                {
                  code: 'SLEEP',
                  name: 'Sleep',
                },
                {
                  code: 'PUBERT',
                  name: 'Puberty',
                },
                {
                  code: 'PILATE',
                  name: 'Pilates',
                },
                {
                  code: 'PAIN',
                  name: 'Pain',
                },
                {
                  code: 'NURSIN',
                  name: 'Nursing',
                },
                {
                  code: 'NATHEA',
                  name: 'Natural Health',
                },
                {
                  code: 'MENSES',
                  name: 'Menstruation',
                },
                {
                  code: 'MENOPA',
                  name: 'Menopause',
                },
                {
                  code: 'HEALIN',
                  name: 'Healing',
                },
                {
                  code: 'EATDIS',
                  name: 'Eating Disorders',
                },
                {
                  code: 'DYSLEX',
                  name: 'Dyslexia',
                },
                {
                  code: 'DIABET',
                  name: 'Diabetes',
                },
                {
                  code: 'DEAFNE',
                  name: 'Deafness Issues',
                },
                {
                  code: 'CANCER',
                  name: 'Cancer',
                },
                {
                  code: 'HAP',
                  name: 'Happiness',
                },
                {
                  code: 'HAPPIN',
                  name: 'Happiness',
                },
                {
                  code: 'HEALTH',
                  name: 'Health',
                },
                {
                  code: 'ABORTI',
                  name: 'Abortion',
                },
                {
                  code: 'ADDICT',
                  name: 'Addiction',
                },
                {
                  code: 'AGEING',
                  name: 'Ageing',
                },
                {
                  code: 'ALCOHO',
                  name: 'Alcohol/Addiction',
                },
                {
                  code: 'ALLERG',
                  name: 'Allergies',
                },
                {
                  code: 'ALZHEI',
                  name: 'Alzheimers',
                },
                {
                  code: 'ANXIET',
                  name: 'Anxiety',
                },
                {
                  code: 'ASPERG',
                  name: 'Aspergers Syndrome',
                },
                {
                  code: 'AUTISM',
                  name: 'Autism',
                },
                {
                  code: 'BACKS',
                  name: 'Backs (Pain)',
                },
                {
                  code: 'BEAUTY',
                  name: 'Beauty',
                },
                {
                  code: 'BODYIM',
                  name: 'Body Image',
                },
                {
                  code: 'MASSAG',
                  name: 'Massage',
                },
              ],
            },
            {
              name: 'DIET & NUTRITION',
              ebilityCategories: [
                {
                  code: 'DIET',
                  name: 'Diet',
                },
                {
                  code: 'NUTRIT',
                  name: 'Nutrition',
                },
              ],
            },
            {
              name: 'MENTAL HEALTH',
              ebilityCategories: [
                {
                  code: 'ADHD',
                  name: 'ADHD',
                },
                {
                  code: 'DEMENT',
                  name: 'Dementia',
                },
                {
                  code: 'EMOTIO',
                  name: 'Emotions',
                },
                {
                  code: 'MENHEA',
                  name: 'Mental Health',
                },
                {
                  code: 'MINDFU',
                  name: 'Mindfulness',
                },
                {
                  code: 'POSTNA',
                  name: 'Postnatal Depression',
                },
                {
                  code: 'PSYCHI',
                  name: 'Psychiatry',
                },
                {
                  code: 'PSYTHE',
                  name: 'Psycho Therapy',
                },
                {
                  code: 'PTS',
                  name: 'Post Traumatic Stress',
                },
                {
                  code: 'STRESS',
                  name: 'Stress',
                },
                {
                  code: 'SUICID',
                  name: 'Suicide',
                },
                {
                  code: 'TRAUMA',
                  name: 'Trauma',
                },
              ],
            },
            {
              name: 'MORTALITY & GRIEF',
              ebilityCategories: [
                {
                  code: 'BEREAV',
                  name: 'Bereavement',
                },
                {
                  code: 'DEATH&',
                  name: 'Death & Dying',
                },
                {
                  code: 'GRIEF',
                  name: 'Grief',
                },
              ],
            },
            {
              name: 'PREGNANCY & PARENTING',
              ebilityCategories: [
                {
                  code: 'BABIES',
                  name: 'Babies',
                },
                {
                  code: 'CHIDEV',
                  name: 'Child Development',
                },
                {
                  code: 'KIDHEA',
                  name: 'Children`s health',
                },
                {
                  code: 'MIDWIF',
                  name: 'Midwifery',
                },
                {
                  code: 'MOTHER',
                  name: 'Motherhood',
                },
                {
                  code: 'NZPARE',
                  name: 'NZ Parenting',
                },
                {
                  code: 'PARAUT',
                  name: 'Parenting Autism',
                },
                {
                  code: 'PARENT',
                  name: 'Parenting',
                },
                {
                  code: 'PREGNA',
                  name: 'Pregnancy',
                },
                {
                  code: 'PREG',
                  name: 'Pregnancy',
                },
              ],
            },
            {
              name: 'SELF HELP',
              ebilityCategories: [
                {
                  code: 'MOTIVA',
                  name: 'Motivation',
                },
                {
                  code: 'NZSELH',
                  name: 'NZ Self Help',
                },
                {
                  code: 'PERSDE',
                  name: 'Personal Development',
                },
                {
                  code: 'POPPSY',
                  name: 'Pop psychology',
                },
                {
                  code: 'SELHEL',
                  name: 'Self Help',
                },
              ],
            },
            {
              name: 'SEX & RELATIONSHIPS',
              ebilityCategories: [
                {
                  code: 'BISEXU',
                  name: 'Bisexuality',
                },
                {
                  code: 'DIVORC',
                  name: 'Divorce',
                },
                {
                  code: 'FEMSEX',
                  name: 'Female Sexuality',
                },
                {
                  code: 'MARRIA',
                  name: 'Marriage',
                },
                {
                  code: 'POLAMO',
                  name: 'Polyamory',
                },
                {
                  code: 'QUESEX',
                  name: 'Queer Sexuality',
                },
                {
                  code: 'RELATI',
                  name: 'Relationships',
                },
                {
                  code: 'SEX',
                  name: 'Sex',
                },
                {
                  code: 'SEXABU',
                  name: 'Sexual Abuse',
                },
                {
                  code: 'SEXEDU',
                  name: 'Sex Education',
                },
                {
                  code: 'SEXPOL',
                  name: 'Sexual Politics',
                },
                {
                  code: 'SEXUAL',
                  name: 'Sexuality',
                },
                {
                  code: 'SEXWOR',
                  name: 'Sex Work',
                },
                {
                  code: 'TEESEX',
                  name: 'Teen Sexuality',
                },
              ],
            },
          ],
        },
        {
          name: 'SOCIETY, CULTURE & TECHNOLOGY',
          subCategories: [
            {
              name: 'SOCIETY & CULTURE',
              ebilityCategories: [
                {
                  code: 'ETHSTU',
                  name: 'Ethnic Studies',
                },
                {
                  code: 'CENSOR',
                  name: 'Censorship',
                },
                {
                  code: 'CLASS',
                  name: 'Class Issues',
                },
                {
                  code: 'CONSUM',
                  name: 'Consumerism',
                },
                {
                  code: 'CONTHE',
                  name: 'Conspiracy Theories',
                },
                {
                  code: 'CULSTU',
                  name: 'Culture Studies',
                },
                {
                  code: 'CULTS',
                  name: 'Cults',
                },
                {
                  code: 'ETHSTU',
                  name: 'Ethnic Studies',
                },
                {
                  code: 'GANGS',
                  name: 'Gangs',
                },
                {
                  code: 'GENOCI',
                  name: 'Genocide',
                },
                {
                  code: 'LAW',
                  name: 'Law',
                },
                {
                  code: 'LEGAL',
                  name: 'Legal',
                },
                {
                  code: 'MARIJU',
                  name: 'Marijuana',
                },
                {
                  code: 'MEDSTU',
                  name: 'Media Studies',
                },
                {
                  code: 'NZSOCI',
                  name: 'NZ Sociology',
                },
                {
                  code: 'PACCUL',
                  name: 'Pacific Cutures',
                },
                {
                  code: 'PEACEI',
                  name: 'Peace Issues',
                },
                {
                  code: 'POLICE',
                  name: 'Police',
                },
                {
                  code: 'POPCUL',
                  name: 'Popular Culture',
                },
                {
                  code: 'POVERT',
                  name: 'Poverty',
                },
                {
                  code: 'PRISON',
                  name: 'Prison',
                },
                {
                  code: 'RACEIS',
                  name: 'Race Issues',
                },
                {
                  code: 'RACISM',
                  name: 'RACISM',
                },
                {
                  code: 'REFUGE',
                  name: 'Refugees',
                },
                {
                  code: 'SOCCOM',
                  name: 'Social Commentary',
                },
                {
                  code: 'SOCIET',
                  name: 'Society',
                },
                {
                  code: 'SOCIOL',
                  name: 'Sociology',
                },
                {
                  code: 'SOCPSY',
                  name: 'Social Psychology',
                },
                {
                  code: 'SOCSCI',
                  name: 'Social Science',
                },
                {
                  code: 'ANTIRA',
                  name: 'Anti-Racism',
                },
                {
                  code: 'RACE',
                  name: 'Race',
                },
              ],
            },
            {
              name: 'TECHNOLOGY',
              ebilityCategories: [
                {
                  code: 'TECHNO',
                  name: 'Technology',
                },
                {
                  code: 'ARTIFI',
                  name: 'Artificial Intellieg',
                },
                {
                  code: 'CODING',
                  name: 'Coding',
                },
                {
                  code: 'COMPUT',
                  name: 'Computers',
                },
                {
                  code: 'CYBER',
                  name: 'Cyber/Hacking',
                },
                {
                  code: 'INTERN',
                  name: 'Internet',
                },
                {
                  code: 'SOCMED',
                  name: 'Social Media',
                },
              ],
            },
            {
              name: 'TRUE CRIME',
              ebilityCategories: [
                {
                  code: 'NZTRUC',
                  name: 'NZ True Crime',
                },
                {
                  code: 'TRUCRI',
                  name: 'True Crime',
                },
              ],
            },
          ],
        },
        {
          name: 'SCIENCE & NATURE',
          subCategories: [
            {
              name: 'SCIENCE & NATURE',
              ebilityCategories: [
                {
                  code: 'BIODIV',
                  name: 'Biodiversity',
                },
              ],
            },
            {
              name: 'ANIMALS',
              ebilityCategories: [
                {
                  code: 'ANICAT',
                  name: 'Cats Animal',
                },
                {
                  code: 'ANIDOG',
                  name: 'Dogs Animal',
                },
                {
                  code: 'ANIHOR',
                  name: 'Horse Animal',
                },
                {
                  code: 'ANIMAL',
                  name: 'Animals',
                },
                {
                  code: 'BEES',
                  name: 'Bees & Beekeeping',
                },
                {
                  code: 'BIRDS',
                  name: 'Birds',
                },
                {
                  code: 'DINOSA',
                  name: 'Dinosaurs',
                },
                {
                  code: 'FISH',
                  name: 'Fish',
                },
                {
                  code: 'HORSES',
                  name: 'Horses',
                },
                {
                  code: 'PETS',
                  name: 'Pets/Pet Care',
                },
              ],
            },
            {
              name: 'BIOLOGY & EVOLUTION',
              ebilityCategories: [
                {
                  code: 'BIOLOG',
                  name: 'Biology',
                },
                {
                  code: 'DARWIN',
                  name: 'Darwinism',
                },
                {
                  code: 'EVOLUT',
                  name: 'Evolution',
                },
                {
                  code: 'EXTINC',
                  name: 'Extinction',
                },
                {
                  code: 'GENETI',
                  name: 'Genetics',
                },
                {
                  code: 'HUMEVO',
                  name: 'Human Evolution',
                },
                {
                  code: 'MARBIO',
                  name: 'Marine Biology',
                },
              ],
            },
            {
              name: 'CLIMATE CHANGE',
              ebilityCategories: [
                {
                  code: 'CLICHA',
                  name: 'Climate Change',
                },
              ],
            },
            {
              name: 'GENERAL SCIENCE',
              ebilityCategories: [
                {
                  code: 'ELECTR',
                  name: 'Electricity',
                },
                {
                  code: 'ENGINE',
                  name: 'Engineering',
                },
                {
                  code: 'FORENS',
                  name: 'Forensic Science',
                },
                {
                  code: 'INVENT',
                  name: 'Inventions',
                },
                {
                  code: 'PHISCI',
                  name: 'Philosophy of Science',
                },
                {
                  code: 'POPSCI',
                  name: 'Popular Science',
                },
                {
                  code: 'SCIBIO',
                  name: 'Science Biography',
                },
                {
                  code: 'SCIENC',
                  name: 'Science & Chaos',
                },
                {
                  code: 'SCIHIS',
                  name: 'Science History',
                },
              ],
            },
            {
              name: 'MATHEMATICS',
              ebilityCategories: [
                {
                  code: 'GEOMET',
                  name: 'Geometry',
                },
                {
                  code: 'MATHEM',
                  name: 'Mathematics',
                },
              ],
            },
            {
              name: 'MEDICINE',
              ebilityCategories: [
                {
                  code: 'ANATOM',
                  name: 'Anatomy',
                },
                {
                  code: 'HIVAID',
                  name: 'HIV/AIDS',
                },
                {
                  code: 'ILLNES',
                  name: 'Illness',
                },
                {
                  code: 'MEDICI',
                  name: 'Medicine',
                },
                {
                  code: 'MEDMEM',
                  name: 'Medical Memoir',
                },
                {
                  code: 'VIRUS',
                  name: 'Viruses, Plagues & Disease',
                },
              ],
            },
            {
              name: 'PHYSICS & CHEMISTRY',
              ebilityCategories: [
                {
                  code: 'CHEMIS',
                  name: 'Chemistry',
                },
                {
                  code: 'PHYSIC',
                  name: 'Physics',
                },
                {
                  code: 'QUANTU',
                  name: 'Quantum Physics',
                },
              ],
            },
            {
              name: 'PSYCHOLOGY & THE BRAIN',
              ebilityCategories: [
                {
                  code: 'BRAIN',
                  name: 'Mind & Brain',
                },
                {
                  code: 'CBT',
                  name: 'Cognitive Behavioural Therapy',
                },
                {
                  code: 'CHIPSY',
                  name: 'Child Psychology',
                },
                {
                  code: 'MEMORY',
                  name: 'Memory',
                },
                {
                  code: 'NEUROS',
                  name: 'Neuroscience',
                },
                {
                  code: 'PSYCHO',
                  name: 'Psychology',
                },
                {
                  code: 'SOCIOP',
                  name: 'Sociopathy/Psychopat',
                },
              ],
            },
            {
              name: 'SPACE & ASTRONOMY',
              ebilityCategories: [
                {
                  code: 'ASTRON',
                  name: 'Astronomy',
                },
                {
                  code: 'ASTROP',
                  name: 'Astrophysics',
                },
                {
                  code: 'COSMOL',
                  name: 'Cosmology',
                },
                {
                  code: 'MOON',
                  name: 'Moon',
                },
                {
                  code: 'SPACE',
                  name: 'Space',
                },
              ],
            },
            {
              name: 'THE NATURAL WORLD',
              ebilityCategories: [
                {
                  code: 'CLIMAT',
                  name: 'Climate',
                },
                {
                  code: 'EARTHQ',
                  name: 'Earthquakes',
                },
                {
                  code: 'ECOLOG',
                  name: 'Ecology',
                },
                {
                  code: 'ENVIRO',
                  name: 'Environment',
                },
                {
                  code: 'FAUNA',
                  name: 'Fauna',
                },
                {
                  code: 'FLAX',
                  name: 'Flax',
                },
                {
                  code: 'FLORA',
                  name: 'Flora',
                },
                {
                  code: 'FORAGE',
                  name: 'Foraging',
                },
                {
                  code: 'FRUIT',
                  name: 'Fruit',
                },
                {
                  code: 'GEOGRA',
                  name: 'Geography',
                },
                {
                  code: 'GEOLOG',
                  name: 'Geology',
                },
                {
                  code: 'INSECT',
                  name: 'Insects',
                },
                {
                  code: 'NATHIS',
                  name: 'Natural History',
                },
                {
                  code: 'NATURE',
                  name: 'Nature',
                },
                {
                  code: 'NZNATU',
                  name: 'NZ Natural History',
                },
                {
                  code: 'OCEANS',
                  name: 'Oceans',
                },
                {
                  code: 'RIVERS',
                  name: 'Rivers',
                },
                {
                  code: 'WATER',
                  name: 'Water',
                },
                {
                  code: 'WEATHE',
                  name: 'Weather',
                },
                {
                  code: 'PLANTS',
                  name: 'Plants',
                },
              ],
            },
          ],
        },
        {
          name: 'BUSINESS & ECONOMICS',
          subCategories: [
            {
              name: 'ECONOMICS',
              ebilityCategories: [
                {
                  code: 'FINANC',
                  name: 'Finance',
                },
                {
                  code: 'CAPITA',
                  name: 'Capitalism',
                },
                {
                  code: 'ECONOM',
                  name: 'Economics',
                },
                {
                  code: 'MONEY',
                  name: 'Money',
                },
                {
                  code: 'NZECON',
                  name: 'NZ Economics',
                },
                {
                  code: 'POLECO',
                  name: 'Political Economy',
                },
                {
                  code: 'TAXATI',
                  name: 'Taxation',
                },
              ],
            },
            {
              name: 'BUSINESS',
              ebilityCategories: [
                {
                  code: 'TEAMBU',
                  name: 'Team Building',
                },
                {
                  code: 'BUSINE',
                  name: 'Business',
                },
                {
                  code: 'LEADER',
                  name: 'Leadership',
                },
                {
                  code: 'MANAGE',
                  name: 'Management',
                },
                {
                  code: 'MARKET',
                  name: 'Marketing',
                },
                {
                  code: 'BRANDS',
                  name: 'Branding (business)',
                },
                {
                  code: 'BUDGET',
                  name: 'Budgeting Advice',
                },
                {
                  code: 'BUSBIO',
                  name: 'Business Biography',
                },
                {
                  code: 'BUSMAN',
                  name: 'Business Management',
                },
                {
                  code: 'CAREER',
                  name: 'Careers',
                },
                {
                  code: 'COACHI',
                  name: 'Coaching',
                },
                {
                  code: 'ENTREP',
                  name: 'Entrepreneurship',
                },
                {
                  code: 'NEGOTI',
                  name: 'Negotiation',
                },
                {
                  code: 'INVEST',
                  name: 'Investing',
                },
                {
                  code: 'NZBUSI',
                  name: 'NZ Business',
                },
                {
                  code: 'PROMAN',
                  name: 'Project Management',
                },
                {
                  code: 'SMABUS',
                  name: 'Small Business',
                },
              ],
            },
            {
              name: 'AOTEAROA NZ BUSINESS',
              ebilityCategories: [
                {
                  code: 'NZBUSI',
                  name: 'NZ Business',
                },
              ],
            },
          ],
        },
      ],
    },
  },
];
